// Comprehensive route data for all taxi routes
// Each route contains vehicles with pricing, visitor's guide, FAQs, and popular routes

const routeData = {
  // Ludhiana Routes
  'ludhiana-delhi': {
    from: 'Ludhiana',
    to: 'Delhi',
    distance: '310 KM',
    duration: '5-6 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Maruti Dzire',
      type: 'Car Type',
      seats: 4,
      luggage: 3,
      price: 4000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_109a9f6bf-1768379759524.png",
      imageAlt: 'White Maruti Dzire sedan car for Ludhiana to Delhi route'
    },
    {
      id: 2,
      name: 'Brezza',
      type: 'Car Type',
      seats: 4,
      luggage: 4,
      price: 5400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ef04795b-1768380108447.png",
      imageAlt: 'Maruti Brezza SUV for Ludhiana to Delhi route'
    },
    {
      id: 3,
      name: 'Maruti Ertiga',
      type: 'Car Type',
      seats: 6,
      luggage: 4,
      price: 5900,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ee6c2ff0-1768328894687.png",
      imageAlt: 'Maruti Ertiga MPV for Ludhiana to Delhi route'
    },
    {
      id: 4,
      name: 'Kia Carens',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 6800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10b72f818-1768380109526.png",
      imageAlt: 'Kia Carens premium MPV for Ludhiana to Delhi route'
    },
    {
      id: 5,
      name: 'Innova Crysta',
      type: 'Car Type',
      seats: 6,
      luggage: 6,
      price: 7700,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b6b7d81f-1767299092512.png",
      imageAlt: 'Toyota Innova Crysta for Ludhiana to Delhi route'
    },
    {
      id: 6,
      name: 'Innova Crysta 7+1',
      type: 'Car Type',
      seats: 7,
      luggage: 6,
      price: 8100,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_179ca4a8c-1768360986311.png",
      imageAlt: 'Toyota Innova Crysta 7+1 seater for Ludhiana to Delhi route'
    },
    {
      id: 7,
      name: 'Innova Hycross',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 9500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18a023f32-1768360986331.png",
      imageAlt: 'Toyota Innova Hycross premium for Ludhiana to Delhi route'
    }],

    visitorsGuide: {
      intro: 'Ludhiana to Delhi taxi service by Advait Tour and Travels offers comfortable and reliable transportation. Book your one-way taxi from Ludhiana to Delhi at affordable rates.',
      sections: [
      {
        title: 'Ludhiana to Delhi One-Way Taxi Service',
        content: 'Travel from Ludhiana to Delhi in comfort with Advait Tour and Travels. Our professional drivers ensure a safe and pleasant journey.'
      }]

    },
    faqs: [
    { question: 'What is the distance from Ludhiana to Delhi?', answer: 'The distance from Ludhiana to Delhi is approximately 310 kilometers via NH44.' },
    { question: 'How long does it take from Ludhiana to Delhi?', answer: 'It takes approximately 5-6 hours to travel from Ludhiana to Delhi by road.' },
    { question: 'What is the Ludhiana to Delhi taxi fare?', answer: 'The taxi fare from Ludhiana to Delhi starts at ₹4000 for a Maruti Dzire.' }],

    popularRoutes: [
    { name: 'Ludhiana to Chandigarh', slug: 'ludhiana-chandigarh' },
    { name: 'Ludhiana to Amritsar', slug: 'ludhiana-amritsar' },
    { name: 'Delhi to Ludhiana', slug: 'delhi-ludhiana' }]

  },
  'ludhiana-chandigarh': {
    from: 'Ludhiana',
    to: 'Chandigarh',
    distance: '110 KM',
    duration: '2-3 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Maruti Dzire',
      type: 'Car Type',
      seats: 4,
      luggage: 3,
      price: 2200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_179ca4a8c-1768360986311.png",
      imageAlt: 'White Maruti Dzire sedan car for Ludhiana to Chandigarh route'
    },
    {
      id: 2,
      name: 'Brezza',
      type: 'Car Type',
      seats: 4,
      luggage: 4,
      price: 2600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_19d89faa6-1768370736021.png",
      imageAlt: 'Maruti Brezza SUV for Ludhiana to Chandigarh route'
    },
    {
      id: 3,
      name: 'Maruti Ertiga',
      type: 'Car Type',
      seats: 6,
      luggage: 4,
      price: 2900,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cecda4a3-1768145557954.png",
      imageAlt: 'Maruti Ertiga MPV for Ludhiana to Chandigarh route'
    },
    {
      id: 4,
      name: 'Kia Carens',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 3300,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1505ca721-1768380111459.png",
      imageAlt: 'Kia Carens premium MPV for Ludhiana to Chandigarh route'
    },
    {
      id: 5,
      name: 'Innova Crysta',
      type: 'Car Type',
      seats: 6,
      luggage: 6,
      price: 3700,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
      imageAlt: 'Toyota Innova Crysta for Ludhiana to Chandigarh route'
    },
    {
      id: 6,
      name: 'Innova Crysta 7+1',
      type: 'Car Type',
      seats: 7,
      luggage: 6,
      price: 4000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ce9df03d-1768360986196.png",
      imageAlt: 'Toyota Innova Crysta 7+1 seater for Ludhiana to Chandigarh route'
    },
    {
      id: 7,
      name: 'Innova Hycross',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 4600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d879e86e-1768360986352.png",
      imageAlt: 'Toyota Innova Hycross premium for Ludhiana to Chandigarh route'
    }],

    visitorsGuide: {
      intro: 'Ludhiana to Chandigarh taxi service by Advait Tour and Travels. Quick and comfortable journey to the City Beautiful.',
      sections: [
      {
        title: 'Ludhiana to Chandigarh One-Way Taxi',
        content: 'Book affordable taxi from Ludhiana to Chandigarh with Advait Tour and Travels. Professional drivers and well-maintained vehicles.'
      }]

    },
    faqs: [
    { question: 'What is the distance from Ludhiana to Chandigarh?', answer: 'The distance is approximately 110 kilometers.' },
    { question: 'How long does it take?', answer: 'It takes about 2-3 hours by road.' },
    { question: 'What is the fare?', answer: 'Fare starts at ₹2200 for Maruti Dzire.' }],

    popularRoutes: [
    { name: 'Ludhiana to Delhi', slug: 'ludhiana-delhi' },
    { name: 'Chandigarh to Ludhiana', slug: 'chandigarh-ludhiana' }]

  },
  'ludhiana-amritsar': {
    from: 'Ludhiana',
    to: 'Amritsar',
    distance: '140 KM',
    duration: '3-4 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Maruti Dzire',
      type: 'Car Type',
      seats: 4,
      luggage: 3,
      price: 3000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_179ca4a8c-1768360986311.png",
      imageAlt: 'White Maruti Dzire sedan car for Ludhiana to Amritsar route'
    },
    {
      id: 2,
      name: 'Brezza',
      type: 'Car Type',
      seats: 4,
      luggage: 4,
      price: 3600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10cab8e06-1768370735456.png",
      imageAlt: 'Maruti Brezza SUV for Ludhiana to Amritsar route'
    },
    {
      id: 3,
      name: 'Maruti Ertiga',
      type: 'Car Type',
      seats: 6,
      luggage: 4,
      price: 3900,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ef04795b-1768380108447.png",
      imageAlt: 'Maruti Ertiga MPV for Ludhiana to Amritsar route'
    },
    {
      id: 4,
      name: 'Kia Carens',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 4500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_118e78774-1768362506599.png",
      imageAlt: 'Kia Carens premium MPV for Ludhiana to Amritsar route'
    },
    {
      id: 5,
      name: 'Innova Crysta',
      type: 'Car Type',
      seats: 6,
      luggage: 6,
      price: 5100,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_156e9743f-1768362507117.png",
      imageAlt: 'Toyota Innova Crysta for Ludhiana to Amritsar route'
    },
    {
      id: 6,
      name: 'Innova Crysta 7+1',
      type: 'Car Type',
      seats: 7,
      luggage: 6,
      price: 5400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ac5f6034-1767621357232.png",
      imageAlt: 'Toyota Innova Crysta 7+1 seater for Ludhiana to Amritsar route'
    },
    {
      id: 7,
      name: 'Innova Hycross',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 6300,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18a023f32-1768360986331.png",
      imageAlt: 'Toyota Innova Hycross premium for Ludhiana to Amritsar route'
    }],

    visitorsGuide: {
      intro: 'Ludhiana to Amritsar taxi service for Golden Temple visit. Comfortable journey with Advait Tour and Travels.',
      sections: [
      {
        title: 'Ludhiana to Amritsar Taxi Booking',
        content: 'Visit the Golden Temple with our reliable taxi service from Ludhiana to Amritsar. Book now for best rates.'
      }]

    },
    faqs: [
    { question: 'Distance from Ludhiana to Amritsar?', answer: 'Approximately 140 kilometers.' },
    { question: 'Travel time?', answer: 'About 3-4 hours by road.' },
    { question: 'Taxi fare?', answer: 'Starting from ₹3000 for Maruti Dzire.' }],

    popularRoutes: [
    { name: 'Amritsar to Ludhiana', slug: 'amritsar-ludhiana' },
    { name: 'Ludhiana to Chandigarh', slug: 'ludhiana-chandigarh' }]

  },
  'ludhiana-shimla': {
    from: 'Ludhiana',
    to: 'Shimla',
    distance: '200 KM',
    duration: '5-6 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Maruti Dzire',
      type: 'Car Type',
      seats: 4,
      luggage: 3,
      price: 3970,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1be7fa069-1768328894291.png",
      imageAlt: 'White Maruti Dzire sedan car for Ludhiana to Shimla route'
    },
    {
      id: 2,
      name: 'Brezza',
      type: 'Car Type',
      seats: 4,
      luggage: 4,
      price: 4800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_128fe23b0-1768380108426.png",
      imageAlt: 'Maruti Brezza SUV for Ludhiana to Shimla route'
    },
    {
      id: 3,
      name: 'Maruti Ertiga',
      type: 'Car Type',
      seats: 6,
      luggage: 4,
      price: 5300,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f5d123de-1768362508924.png",
      imageAlt: 'Maruti Ertiga MPV for Ludhiana to Shimla route'
    },
    {
      id: 4,
      name: 'Kia Carens',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 6100,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ce9df03d-1768360986196.png",
      imageAlt: 'Kia Carens premium MPV for Ludhiana to Shimla route'
    },
    {
      id: 5,
      name: 'Innova Crysta',
      type: 'Car Type',
      seats: 6,
      luggage: 6,
      price: 6900,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_156e9743f-1768362507117.png",
      imageAlt: 'Toyota Innova Crysta for Ludhiana to Shimla route'
    },
    {
      id: 6,
      name: 'Innova Crysta 7+1',
      type: 'Car Type',
      seats: 7,
      luggage: 6,
      price: 7300,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_179ca4a8c-1768360986311.png",
      imageAlt: 'Toyota Innova Crysta 7+1 seater for Ludhiana to Shimla route'
    },
    {
      id: 7,
      name: 'Innova Hycross',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 8500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
      imageAlt: 'Toyota Innova Hycross premium for Ludhiana to Shimla route'
    }],

    visitorsGuide: {
      intro: 'Ludhiana to Shimla taxi service for a memorable hill station experience. Enjoy scenic mountain views with Advait Tour and Travels.',
      sections: [
      {
        title: 'Ludhiana to Shimla Cab Booking',
        content: 'Plan your Shimla trip from Ludhiana with our comfortable taxi service. Book online for best deals.'
      }]

    },
    faqs: [
    { question: 'Distance from Ludhiana to Shimla?', answer: 'About 200 kilometers.' },
    { question: 'How long is the journey?', answer: 'Approximately 5-6 hours.' },
    { question: 'Taxi fare?', answer: 'Starts at ₹3970 for Maruti Dzire.' }],

    popularRoutes: [
    { name: 'Shimla to Ludhiana', slug: 'shimla-ludhiana' },
    { name: 'Ludhiana to Manali', slug: 'ludhiana-manali' }]

  },
  'ludhiana-manali': {
    from: 'Ludhiana',
    to: 'Manali',
    distance: '280 KM',
    duration: '7-8 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Maruti Dzire',
      type: 'Car Type',
      seats: 4,
      luggage: 3,
      price: 5233,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1be7fa069-1768328894291.png",
      imageAlt: 'White Maruti Dzire sedan car for Ludhiana to Manali route'
    },
    {
      id: 2,
      name: 'Brezza',
      type: 'Car Type',
      seats: 4,
      luggage: 4,
      price: 6300,
      image: "https://images.unsplash.com/photo-1642345810417-eecf7dda339b",
      imageAlt: 'Maruti Brezza SUV for Ludhiana to Manali route'
    },
    {
      id: 3,
      name: 'Maruti Ertiga',
      type: 'Car Type',
      seats: 6,
      luggage: 4,
      price: 6900,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cecda4a3-1768145557954.png",
      imageAlt: 'Maruti Ertiga MPV for Ludhiana to Manali route'
    },
    {
      id: 4,
      name: 'Kia Carens',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 7900,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_177893f29-1768377418212.png",
      imageAlt: 'Kia Carens premium MPV for Ludhiana to Manali route'
    },
    {
      id: 5,
      name: 'Innova Crysta',
      type: 'Car Type',
      seats: 6,
      luggage: 6,
      price: 8900,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
      imageAlt: 'Toyota Innova Crysta for Ludhiana to Manali route'
    },
    {
      id: 6,
      name: 'Innova Crysta 7+1',
      type: 'Car Type',
      seats: 7,
      luggage: 6,
      price: 9400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_156e9743f-1768362507117.png",
      imageAlt: 'Toyota Innova Crysta 7+1 seater for Ludhiana to Manali route'
    },
    {
      id: 7,
      name: 'Innova Hycross',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 11000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16b725c90-1768360984929.png",
      imageAlt: 'Toyota Innova Hycross premium for Ludhiana to Manali route'
    }],

    visitorsGuide: {
      intro: 'Ludhiana to Manali taxi service for an unforgettable Himalayan adventure. Experience the beauty of mountains with Advait Tour and Travels.',
      sections: [
      {
        title: 'Ludhiana to Manali Taxi Service',
        content: 'Book your Manali trip from Ludhiana with our premium taxi service. Comfortable vehicles and experienced drivers ensure a safe journey.'
      }]

    },
    faqs: [
    { question: 'Distance from Ludhiana to Manali?', answer: 'Approximately 280 kilometers.' },
    { question: 'Travel duration?', answer: 'About 7-8 hours by road.' },
    { question: 'Cab fare?', answer: 'Starting from ₹5233 for Maruti Dzire.' }],

    popularRoutes: [
    { name: 'Manali to Ludhiana', slug: 'manali-ludhiana' },
    { name: 'Ludhiana to Shimla', slug: 'ludhiana-shimla' }]

  },

  'delhi-ludhiana': {
    from: 'Delhi',
    to: 'Ludhiana',
    distance: '310 KM',
    duration: '5-6 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Maruti Dzire',
      type: 'Car Type',
      seats: 4,
      luggage: 3,
      price: 4000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1be7fa069-1768328894291.png",
      imageAlt: 'White Maruti Dzire sedan car for Delhi to Ludhiana route'
    },
    {
      id: 2,
      name: 'Brezza',
      type: 'Car Type',
      seats: 4,
      luggage: 4,
      price: 5400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_19d89faa6-1768370736021.png",
      imageAlt: 'Maruti Brezza SUV for Delhi to Ludhiana route'
    },
    {
      id: 3,
      name: 'Maruti Ertiga',
      type: 'Car Type',
      seats: 6,
      luggage: 4,
      price: 5900,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cecda4a3-1768145557954.png",
      imageAlt: 'Maruti Ertiga MPV for Delhi to Ludhiana route'
    },
    {
      id: 4,
      name: 'Kia Carens',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 6800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10b72f818-1768380109526.png",
      imageAlt: 'Kia Carens premium MPV for Delhi to Ludhiana route'
    },
    {
      id: 5,
      name: 'Innova Crysta',
      type: 'Car Type',
      seats: 6,
      luggage: 6,
      price: 7700,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_191a16012-1768368473200.png",
      imageAlt: 'Toyota Innova Crysta for Delhi to Ludhiana route'
    },
    {
      id: 6,
      name: 'Innova Crysta 7+1',
      type: 'Car Type',
      seats: 7,
      luggage: 6,
      price: 8100,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ac5f6034-1767621357232.png",
      imageAlt: 'Toyota Innova Crysta 7+1 seater for Delhi to Ludhiana route'
    },
    {
      id: 7,
      name: 'Innova Hycross',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 9500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18a023f32-1768360986331.png",
      imageAlt: 'Toyota Innova Hycross premium for Delhi to Ludhiana route'
    }],

    visitorsGuide: {
      intro: 'Delhi to Ludhiana 310 KM, from Delhi to Ludhiana, seems to be a long distance. However, you can ensure it to be safe, relaxing and convenient by booking our taxi services. Advait Tour and Travels is available at your service for providing reliable and affordable taxi services. No matter how many people you are and at what time you need to travel, we are always there to assist you with your taxi requirements. Choose from Toyota Etios, Maruti Dzire, Maruti Ertiga, Toyota Innova, Toyota Crysta, Tempo Traveler, and more. You can view the rates mentioned with each of these options. The mentioned rates are all you need to pay as the tax is already included and there is no other fee. If you are worried about safety, let us tell you that all our trips are examined for safety and convenience. Your comfort, safety, and satisfaction are our top priorities. Our experienced and friendly drivers will fill your Delhi to Ludhiana trip with fun and will make it memorable for you. So what you are waiting for? Book your taxi with Advait Tour and Travels now!',
      sections: [
      {
        title: 'Your One-Stop Solution for Seamless Delhi to Ludhiana One-Way Taxi Services',
        content: 'Are you tired of planning your travel itinerary around fixed return journeys? Do you find booking taxis for one-way trips cumbersome? Look no further than Advait Tour and Travels – your reliable companion for hassle-free one-way taxi services Delhi to Ludhiana.'
      },
      {
        title: 'Why Choose Advait Tour and Travels for Your One-Way Journeys?',
        content: 'At Advait Tour and Travels, we understand that your travel needs may not always fit into the conventional round-trip model. Whether you\'re going on a business trip, a vacation, or simply need a comfortable ride to your destination, our Delhi to Ludhiana one-way taxi services are tailored to meet your unique requirements.'
      },
      {
        title: '1. Seamless Booking Process',
        content: 'Our user-friendly website make booking your Delhi to Ludhiana one-way taxi easy. With just a few clicks, you can select your vehicle, specify your pick-up and drop-off locations, and choose from our range of services. No more tedious forms or unnecessary complications – we believe in simplicity.'
      },
      {
        title: '2. Wide Range of Vehicles',
        content: 'At Advait Tour and Travels, we take pride in our diverse fleet of well-maintained vehicles. Whether you prefer a luxury sedan, a spacious SUV, or an economical hatchback, we have the perfect ride for you. Our vehicles undergo regular maintenance checks to ensure a safe and comfortable journey for every passenger.'
      },
      {
        title: '3. Professional Drivers',
        content: 'Your safety and satisfaction are our top priorities. Our drivers are trained professionals dedicated to providing a pleasant and secure travel experience. Expect punctuality, courtesy, and a commitment to making your journey with Advait Tour and Travels a memorable one.'
      },
      {
        title: '4. Transparent Pricing',
        content: 'No hidden costs or last-minute surprises – our pricing is transparent and competitive. With Advait Tour and Travels, you can enjoy the peace of mind that comes with knowing the exact cost of your Delhi to Ludhiana one-way cab service upfront. We believe in building trust through honesty and reliability.'
      },
      {
        title: '5. 24/7 Customer Support',
        content: 'Have a question or need assistance during your journey? Our dedicated customer support team is available 24/7 to address your queries and concerns. Your satisfaction is our priority, and we are here to ensure a smooth and enjoyable travel experience.'
      },
      {
        title: '6. Coverage Across Regions',
        content: 'Advait Tour and Travels isn\'t confined to just one city or region – our services extend across a wide network of destinations. Whether you\'re traveling within the city, between cities, or even across state borders, Advait Tour and Travels has got you covered.'
      },
      {
        title: '7. Comfort',
        content: 'Our modern fleet of vehicles is designed with your comfort in mind. Whether you are traveling alone or with a group, you can enjoy a smooth ride in well-appointed, air-conditioned cars that cater to your every need. We prioritize your comfort, ensuring that you arrive at your destination refreshed and ready to seize the day.'
      },
      {
        title: '8. Easy Online Reservations',
        content: 'Booking your one-way taxi Delhi to Ludhiana with Advait Tour and Travels is easy. Simply visit our website, choose your destination and pickup point, select your preferred vehicle, and voilà – your journey is booked in just a few clicks.'
      },
      {
        title: '9. Real-Time Tracking',
        content: 'Stay in control with real-time tracking. Monitor the progress of your journey and know exactly when your Advait Tour and Travels taxi will arrive.'
      },
      {
        title: 'Book Your One-Way Taxi with Advait Tour and Travels Today',
        content: 'Say goodbye to the limitations of round-trip bookings and experience the freedom of one-way travel with Advait Tour and Travels. Our commitment from competitive pricing to customer satisfaction, makes us the preferred choice for travelers seeking convenience and reliability. Ready to embark on a stress-free one-way journey? Book your taxi Delhi to Ludhiana with Advait Tour and Travels and let us redefine your travel experience. Your destination awaits, and we\'re here to take you there – one way at a time.'
      },
      {
        title: 'Experience the Incredible One-Way Taxi Services from Delhi to Ludhiana by Advait Tour and Travels',
        content: 'With Advait Tour and Travels\'s excellent services of one-way taxi from Delhi to Ludhiana, you may start your journey in luxury and ease. Every trip demonstrates our dedication to offering hassle-free travel experiences, ensuring you arrive at your destination in grace. Avoid the hassles of traditional travel by learning how simple it is to book a Delhi to Ludhiana one way taxi with just a few clicks. Our fleet of impeccable cars is ready to drive you to Ludhiana with ease, whether you\'re arriving at Delhi or beginning your trip from the city center. We at Advait Tour and Travels know how important it is to have a hassle-free travel, and our one-way cab from Delhi to Ludhiana makes sure of that. Savor the ease of a dependable and timely service, freeing you to concentrate on taking in the beautiful journey between these two energetic cities. Concerned about the fare? Transparency is of the utmost importance to Advait Tour and Travels. View our affordable Delhi to Ludhiana one way taxi fare, which provides you with economical options without sacrificing quality. Our dedication to affordability is evident in the breadth of services we offer, such as taxi hire from Delhi to Ludhiana. Advait Tour and Travels promises stress-free travel, so it\'s more than simply a transportation service. Make your cab reservation for one way today, and let us to make your trip from Delhi to Ludhiana as enjoyable as the locations themselves. When you book Delhi to Ludhiana taxi one way with Advait Tour and Travels, each journey is an adventure!.'
      }]

    },
    faqs: [
    { question: 'What is the travel distance from Delhi to Ludhiana', answer: 'The travel distance from Delhi to Ludhiana is approximately 310 kilometers via NH44.' },
    { question: 'How long does it take from Delhi to Ludhiana by road', answer: 'It takes approximately 5-6 hours to travel from Delhi to Ludhiana by road, depending on traffic conditions.' },
    { question: 'Is it safe to travel from Delhi to Ludhiana at night with Advait Tour and Travels?', answer: 'Yes, it is absolutely safe to travel at night with Advait Tour and Travels. All our drivers are verified, experienced, and our vehicles are equipped with GPS tracking for your safety.' },
    { question: 'What is the Delhi to Ludhiana taxi fare with Advait Tour and Travels?', answer: 'The taxi fare from Delhi to Ludhiana starts at ₹4000 for a Maruti Dzire and goes up to ₹9500 for an Innova Hycross, depending on the vehicle type you choose.' },
    { question: 'How much is the Delhi to Ludhiana Innova fare with Advait Tour and Travels?', answer: 'The Innova Crysta fare from Delhi to Ludhiana is ₹7700, and the Innova Hycross fare is ₹9500.' },
    { question: 'What is the lowest taxi fare from Delhi to Ludhiana with Advait Tour and Travels?', answer: 'The lowest taxi fare from Delhi to Ludhiana is ₹4000 for a Maruti Dzire sedan.' },
    { question: 'Does the price include driver charges and night charges in Advait Tour and Travels cabs?', answer: 'Yes, all our prices are inclusive of driver charges, toll taxes, and state taxes.' },
    { question: 'Do I need to pay in advance to book Delhi to Ludhiana cab with Advait Tour and Travels?', answer: 'A small advance payment may be required to confirm your booking. The remaining amount can be paid after the journey completion.' },
    { question: 'Is sightseeing included in Delhi to Ludhiana cab service by Advait Tour and Travels?', answer: 'Our Delhi to Ludhiana service is primarily a point-to-point transfer. However, you can request stops along the way, and our drivers will accommodate reasonable requests.' },
    { question: 'How early should I book Delhi to Ludhiana taxi with Advait Tour and Travels?', answer: 'We recommend booking at least 24 hours in advance to ensure vehicle availability, though we also accept last-minute bookings subject to availability.' },
    { question: 'Can I book a Delhi to Ludhiana cab with Advait Tour and Travels over the phone?', answer: 'Yes, you can book by calling us at +91-79986-66660. Our customer support team is available 24/7 to assist you.' },
    { question: 'Can we pick up passengers on the way in Delhi to Ludhiana one-way Advait Tour and Travels taxi?', answer: 'Yes, you can pick up passengers along the route. Please inform us during booking so we can plan accordingly.' },
    { question: 'Do I need to pay both side toll tax in one-way Delhi to Ludhiana taxi?', answer: 'No, for one-way trips, you only pay one-side toll charges which are already included in the quoted fare.' },
    { question: 'When will I receive driver and car details from Advait Tour and Travels?', answer: 'You will receive driver and vehicle details 2-3 hours before your scheduled pickup time via SMS and email.' },
    { question: 'Do I need to register on Advait Tour and Travels website for booking?', answer: 'Registration is not mandatory. You can book as a guest, though registering helps you track your bookings and avail special offers.' },
    { question: 'Can I travel with pets in Advait Tour and Travels taxi?', answer: 'Yes, you can travel with pets. Please inform us during booking so we can arrange a suitable vehicle.' },
    { question: 'What types of vehicles does Advait Tour and Travels provide for Delhi to Ludhiana trips?', answer: 'We provide Maruti Dzire, Brezza, Maruti Ertiga, Kia Carens, Innova Crysta, Innova Crysta 7+1, and Innova Hycross for Delhi to Ludhiana trips.' },
    { question: 'Can I book a round-trip Delhi to Ludhiana taxi with Advait Tour and Travels?', answer: 'Yes, we offer both one-way and round-trip taxi services from Delhi to Ludhiana at competitive rates.' },
    { question: 'How do I book Delhi to Ludhiana one-way taxi with Advait Tour and Travels?', answer: 'You can book through our website, mobile app, or by calling +91-79986-66660. The booking process is simple and takes just a few minutes.' },
    { question: 'Are Advait Tour and Travels drivers professional and experienced?', answer: 'Yes, all our drivers are professionally trained, experienced, verified, and hold valid licenses. They are courteous and know the routes well.' },
    { question: 'Can I make stops during Delhi to Ludhiana taxi ride with Advait Tour and Travels?', answer: 'Yes, you can request stops for refreshments, meals, or other needs. Our drivers will accommodate reasonable stop requests.' },
    { question: 'Does Advait Tour and Travels provide sightseeing tours in Delhi?', answer: 'Yes, we provide customized sightseeing tours in Delhi and other cities. Please contact us for tour packages and pricing.' },
    { question: 'Can I book a luxury car for Delhi to Ludhiana taxi with Advait Tour and Travels?', answer: 'Yes, we offer premium vehicles like Innova Hycross and Innova Crysta for a luxurious travel experience.' },
    { question: 'What amenities are available in Advait Tour and Travels vehicles?', answer: 'All our vehicles are equipped with AC, music system, comfortable seating, and ample luggage space. Premium vehicles have additional amenities.' },
    { question: 'What should I do if I leave something in a Advait Tour and Travels taxi?', answer: 'Contact our customer support immediately at +91-79986-66660. We will coordinate with the driver to retrieve your belongings.' },
    { question: 'Can I leave a review about my Advait Tour and Travels experience?', answer: 'Yes, we encourage customers to leave reviews on our website or Google. Your feedback helps us improve our services.' },
    { question: 'What payment options does Advait Tour and Travels accept?', answer: 'We accept cash, credit/debit cards, UPI, net banking, and digital wallets for your convenience.' },
    { question: 'Does Advait Tour and Travels provide late-night or early-morning Delhi to Ludhiana taxis?', answer: 'Yes, our service is available 24/7. You can book taxis for any time, including late-night and early-morning departures.' },
    { question: 'Is it safe to travel at night from Delhi to Ludhiana with Advait Tour and Travels?', answer: 'Absolutely. Our drivers are experienced in night driving, vehicles have GPS tracking, and we provide 24/7 customer support for your safety.' }],

    popularRoutesFrom: [
    { from: 'Delhi', to: 'Chandigarh', price: 3200 },
    { from: 'Delhi', to: 'Ludhiana', price: 4000 },
    { from: 'Delhi', to: 'Kharar', price: 3500 },
    { from: 'Delhi', to: 'Ambala', price: 3000 },
    { from: 'Delhi', to: 'Baddi', price: 4800 },
    { from: 'Delhi', to: 'Jammu', price: 7500 },
    { from: 'Delhi', to: 'Kalka', price: 3800 },
    { from: 'Delhi', to: 'Kurali', price: 3700 },
    { from: 'Delhi', to: 'Kurukshetra', price: 3200 },
    { from: 'Delhi', to: 'Mohali', price: 3200 },
    { from: 'Delhi', to: 'Morinda', price: 4200 },
    { from: 'Delhi', to: 'Panchkula', price: 3200 }],

    popularRoutesTo: [
    { from: 'Ludhiana', to: 'Chandigarh', price: 2000 },
    { from: 'Ludhiana', to: 'Delhi', price: 4200 },
    { from: 'Ludhiana', to: 'Gurugram', price: 4800 },
    { from: 'Ludhiana', to: 'Noida', price: 4800 },
    { from: 'Ludhiana', to: 'Faridabad', price: 4800 },
    { from: 'Ludhiana', to: 'Ghaziabad', price: 4800 },
    { from: 'Ludhiana', to: 'Amritsar', price: 3000 },
    { from: 'Ludhiana', to: 'Shimla', price: 5000 },
    { from: 'Ludhiana', to: 'Manali', price: 5000 },
    { from: 'Ludhiana', to: 'Pathankot', price: 3500 },
    { from: 'Ludhiana', to: 'Dharamshala', price: 4500 },
    { from: 'Ludhiana', to: 'Jammu', price: 4000 }]

  },
  'chandigarh-haridwar': {
    from: 'Chandigarh',
    to: 'Haridwar',
    distance: '203 KM',
    duration: '5 h 10 min',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Maruti Dzire',
      type: 'Car Type',
      seats: 4,
      luggage: 3,
      price: 3500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_191a16012-1768368473200.png",
      imageAlt: 'White Maruti Dzire sedan car for Chandigarh to Haridwar route'
    },
    {
      id: 2,
      name: 'Brezza',
      type: 'Car Type',
      seats: 4,
      luggage: 4,
      price: 4200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_152c5a234-1768362508795.png",
      imageAlt: 'Maruti Brezza SUV for Chandigarh to Haridwar route'
    },
    {
      id: 3,
      name: 'Maruti Ertiga',
      type: 'Car Type',
      seats: 6,
      luggage: 4,
      price: 4600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cecda4a3-1768145557954.png",
      imageAlt: 'Maruti Ertiga MPV for Chandigarh to Haridwar route'
    },
    {
      id: 4,
      name: 'Kia Carens',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 5300,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10b72f818-1768380109526.png",
      imageAlt: 'Kia Carens premium MPV for Chandigarh to Haridwar route'
    },
    {
      id: 5,
      name: 'Innova Crysta',
      type: 'Car Type',
      seats: 6,
      luggage: 6,
      price: 6000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_152c5a234-1768362508795.png",
      imageAlt: 'Toyota Innova Crysta for Chandigarh to Haridwar route'
    },
    {
      id: 6,
      name: 'Innova Crysta 7+1',
      type: 'Car Type',
      seats: 7,
      luggage: 6,
      price: 6300,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_17142d727-1768366661943.png",
      imageAlt: 'Toyota Innova Crysta 7+1 seater for Chandigarh to Haridwar route'
    },
    {
      id: 7,
      name: 'Innova Hycross',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 7400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b2006110-1768379490868.png",
      imageAlt: 'Toyota Innova Hycross premium for Chandigarh to Haridwar route'
    }],

    visitorsGuide: {
      intro: 'The distance between Chandigarh to Haridwar is 203kms which takes around 5 h 10 min. The travel will cover places including Ambala, Yamuna Nagar, and Saharanpur. The roads are quite well maintained and easy-going, but for a stress-free trip, you can consider hiring a cab. You can get to hire affordable cabs including Non AC, AC, Sedan, SUV, and Tempo Traveller for both one-way and round-trip.',
      sections: [
      {
        title: 'Your One-Stop Solution for Seamless Chandigarh to Haridwar One-Way Taxi Services',
        content: 'Are you tired of planning your travel itinerary around fixed return journeys? Do you find booking taxis for one-way trips cumbersome? Look no further than Advait Tour and Travels – your reliable companion for hassle-free one-way taxi services Chandigarh to Haridwar.'
      },
      {
        title: 'Why Choose Advait Tour and Travels for Your One-Way Journeys?',
        content: 'At Advait Tour and Travels, we understand that your travel needs may not always fit into the conventional round-trip model. Whether you\'re going on a business trip, a vacation, or simply need a comfortable ride to your destination, our Chandigarh to Haridwar one-way taxi services are tailored to meet your unique requirements.'
      },
      {
        title: '1. Seamless Booking Process',
        content: 'Our user-friendly website make booking your Chandigarh to Haridwar one-way taxi easy. With just a few clicks, you can select your vehicle, specify your pick-up and drop-off locations, and choose from our range of services. No more tedious forms or unnecessary complications – we believe in simplicity.'
      },
      {
        title: '2. Wide Range of Vehicles',
        content: 'At Advait Tour and Travels, we take pride in our diverse fleet of well-maintained vehicles. Whether you prefer a luxury sedan, a spacious SUV, or an economical hatchback, we have the perfect ride for you. Our vehicles undergo regular maintenance checks to ensure a safe and comfortable journey for every passenger.'
      },
      {
        title: '3. Professional Drivers',
        content: 'Your safety and satisfaction are our top priorities. Our drivers are trained professionals dedicated to providing a pleasant and secure travel experience. Expect punctuality, courtesy, and a commitment to making your journey with Advait Tour and Travels a memorable one.'
      },
      {
        title: '4. Transparent Pricing',
        content: 'No hidden costs or last-minute surprises – our pricing is transparent and competitive. With Advait Tour and Travels, you can enjoy the peace of mind that comes with knowing the exact cost of your Chandigarh to Haridwar one-way cab service upfront. We believe in building trust through honesty and reliability.'
      },
      {
        title: '5. 24/7 Customer Support',
        content: 'Have a question or need assistance during your journey? Our dedicated customer support team is available 24/7 to address your queries and concerns. Your satisfaction is our priority, and we are here to ensure a smooth and enjoyable travel experience.'
      },
      {
        title: '6. Coverage Across Regions',
        content: 'Advait Tour and Travels isn\'t confined to just one city or region – our services extend across a wide network of destinations. Whether you\'re traveling within the city, between cities, or even across state borders, Advait Tour and Travels has got you covered.'
      },
      {
        title: '7. Comfort',
        content: 'Our modern fleet of vehicles is designed with your comfort in mind. Whether you are traveling alone or with a group, you can enjoy a smooth ride in well-appointed, air-conditioned cars that cater to your every need. We prioritize your comfort, ensuring that you arrive at your destination refreshed and ready to seize the day.'
      },
      {
        title: '8. Easy Online Reservations',
        content: 'Booking your one-way taxi Chandigarh to Haridwar with Advait Tour and Travels is easy. Simply visit our website, choose your destination and pickup point, select your preferred vehicle, and voilà – your journey is booked in just a few clicks.'
      },
      {
        title: '9. Real-Time Tracking',
        content: 'Stay in control with real-time tracking. Monitor the progress of your journey and know exactly when your Advait Tour and Travels taxi will arrive.'
      },
      {
        title: 'Book Your One-Way Taxi with Advait Tour and Travels Today',
        content: 'Say goodbye to the limitations of round-trip bookings and experience the freedom of one-way travel with Advait Tour and Travels. Our commitment from competitive pricing to customer satisfaction, makes us the preferred choice for travelers seeking convenience and reliability. Ready to embark on a stress-free one-way journey? Book your taxi Chandigarh to Haridwar with Advait Tour and Travels and let us redefine your travel experience. Your destination awaits, and we\'re here to take you there – one way at a time.'
      },
      {
        title: 'Experience the Incredible One-Way Taxi Services from Chandigarh to Haridwar by Advait Tour and Travels',
        content: 'With Advait Tour and Travels\'s excellent services of one-way taxi from Chandigarh to Haridwar, you may start your journey in luxury and ease. Every trip demonstrates our dedication to offering hassle-free travel experiences, ensuring you arrive at your destination in grace. Avoid the hassles of traditional travel by learning how simple it is to book a Chandigarh to Haridwar one way taxi with just a few clicks. Our fleet of impeccable cars is ready to drive you to Haridwar with ease, whether you\'re arriving at Chandigarh or beginning your trip from the city center. We at Advait Tour and Travels know how important it is to have a hassle-free travel, and our one-way cab from Chandigarh to Haridwar makes sure of that. Savor the ease of a dependable and timely service, freeing you to concentrate on taking in the beautiful journey between these two energetic cities. Concerned about the fare? Transparency is of the utmost importance to Advait Tour and Travels. View our affordable Chandigarh to Haridwar one way taxi fare, which provides you with economical options without sacrificing quality. Our dedication to affordability is evident in the breadth of services we offer, such as taxi hire from Chandigarh to Haridwar. Advait Tour and Travels promises stress-free travel, so it\'s more than simply a transportation service. Make your cab reservation for one way today, and let us to make your trip from Chandigarh to Haridwar as enjoyable as the locations themselves. When you book Chandigarh to Haridwar taxi one way with Advait Tour and Travels, each journey is an adventure!.'
      }]

    },
    faqs: [
    { question: 'What is the travel distance from Chandigarh to Haridwar', answer: 'The travel distance from Chandigarh to Haridwar is approximately 203 kilometers.' },
    { question: 'How long does it take from Chandigarh to Haridwar by road', answer: 'It takes approximately 5 hours 10 minutes to travel from Chandigarh to Haridwar by road.' },
    { question: 'Is it safe to travel from Chandigarh to Haridwar at night with Advait Tour and Travels?', answer: 'Yes, it is absolutely safe to travel at night with Advait Tour and Travels. All our drivers are verified and experienced.' },
    { question: 'What is the Chandigarh to Haridwar taxi fare with Advait Tour and Travels?', answer: 'The taxi fare from Chandigarh to Haridwar starts at ₹3500 for a Maruti Dzire.' },
    { question: 'How much is the Chandigarh to Haridwar Innova fare with Advait Tour and Travels?', answer: 'The Innova Crysta fare from Chandigarh to Haridwar is ₹6000.' },
    { question: 'What is the lowest taxi fare from Chandigarh to Haridwar with Advait Tour and Travels?', answer: 'The lowest taxi fare is ₹3500 for a Maruti Dzire sedan.' },
    { question: 'Does the price include driver charges and night charges in Advait Tour and Travels cabs?', answer: 'Yes, all prices include driver charges, toll taxes, and state taxes.' },
    { question: 'Do I need to pay in advance to book Chandigarh to Haridwar cab with Advait Tour and Travels?', answer: 'A small advance payment may be required to confirm your booking.' },
    { question: 'Is sightseeing included in Chandigarh to Haridwar cab service by Advait Tour and Travels?', answer: 'This is primarily a point-to-point transfer, but you can request stops along the way.' },
    { question: 'How early should I book Chandigarh to Haridwar taxi with Advait Tour and Travels?', answer: 'We recommend booking at least 24 hours in advance.' },
    { question: 'Can I book a Chandigarh to Haridwar cab with Advait Tour and Travels over the phone?', answer: 'Yes, you can book by calling +91-79986-66660.' },
    { question: 'Can we pick up passengers on the way in Chandigarh to Haridwar one-way Advait Tour and Travels taxi?', answer: 'Yes, you can pick up passengers along the route.' },
    { question: 'Do I need to pay both side toll tax in one-way Chandigarh to Haridwar taxi?', answer: 'No, for one-way trips, only one-side toll charges apply.' },
    { question: 'When will I receive driver and car details from Advait Tour and Travels?', answer: 'You will receive details 2-3 hours before pickup time.' },
    { question: 'Do I need to register on Advait Tour and Travels website for booking?', answer: 'Registration is not mandatory.' },
    { question: 'Can I travel with pets in Advait Tour and Travels taxi?', answer: 'Yes, please inform us during booking.' },
    { question: 'What types of vehicles does Advait Tour and Travels provide for Chandigarh to Haridwar trips?', answer: 'We provide Maruti Dzire, Brezza, Ertiga, Kia Carens, Innova Crysta, and more.' },
    { question: 'Can I book a round-trip Chandigarh to Haridwar taxi with Advait Tour and Travels?', answer: 'Yes, we offer both one-way and round-trip services.' },
    { question: 'How do I book Chandigarh to Haridwar one-way taxi with Advait Tour and Travels?', answer: 'Book through our website, app, or call +91-79986-66660.' },
    { question: 'Are Advait Tour and Travels drivers professional and experienced?', answer: 'Yes, all drivers are professionally trained and experienced.' },
    { question: 'Can I make stops during Chandigarh to Haridwar taxi ride with Advait Tour and Travels?', answer: 'Yes, you can request stops for meals or refreshments.' },
    { question: 'Does Advait Tour and Travels provide sightseeing tours in Delhi?', answer: 'Yes, we provide customized sightseeing tours.' },
    { question: 'Can I book a luxury car for Chandigarh to Haridwar taxi with Advait Tour and Travels?', answer: 'Yes, we offer premium vehicles like Innova Hycross.' },
    { question: 'What amenities are available in Advait Tour and Travels vehicles?', answer: 'All vehicles have AC, music system, and comfortable seating.' },
    { question: 'What should I do if I leave something in a Advait Tour and Travels taxi?', answer: 'Contact customer support immediately at +91-79986-66660.' },
    { question: 'Can I leave a review about my Advait Tour and Travels experience?', answer: 'Yes, we encourage reviews on our website or Google.' },
    { question: 'What payment options does Advait Tour and Travels accept?', answer: 'We accept cash, cards, UPI, and digital wallets.' },
    { question: 'Does Advait Tour and Travels provide late-night or early-morning Chandigarh to Haridwar taxis?', answer: 'Yes, our service is available 24/7.' },
    { question: 'Is it safe to travel at night from Chandigarh to Haridwar with Advait Tour and Travels?', answer: 'Absolutely, with GPS tracking and 24/7 support.' }],

    popularRoutesFrom: [
    { from: 'Chandigarh', to: 'Faridabad', price: 3700 },
    { from: 'Chandigarh', to: 'Ghaziabad', price: 3700 },
    { from: 'Chandigarh', to: 'Noida', price: 3800 },
    { from: 'Chandigarh', to: 'Gurugram', price: 3800 },
    { from: 'Chandigarh', to: 'Delhi', price: 3200 },
    { from: 'Chandigarh', to: 'Ambala', price: 1600 },
    { from: 'Chandigarh', to: 'Baddi', price: 2000 },
    { from: 'Chandigarh', to: 'Haridwar', price: 3500 },
    { from: 'Chandigarh', to: 'Jammu', price: 4200 },
    { from: 'Chandigarh', to: 'Ludhiana', price: 2200 },
    { from: 'Chandigarh', to: 'Manali', price: 4500 },
    { from: 'Chandigarh', to: 'Pathankot', price: 3500 }],

    popularRoutesTo: [
    { from: 'Haridwar', to: 'Chandigarh', price: 3500 },
    { from: 'Haridwar', to: 'Delhi', price: 3500 },
    { from: 'Haridwar', to: 'Gurugram', price: 4000 },
    { from: 'Haridwar', to: 'Noida', price: 3500 },
    { from: 'Haridwar', to: 'Faridabad', price: 3800 },
    { from: 'Haridwar', to: 'Ghaziabad', price: 3800 },
    { from: 'Haridwar', to: 'Amritsar', price: 7000 },
    { from: 'Haridwar', to: 'Shimla', price: 6000 },
    { from: 'Haridwar', to: 'Manali', price: 8000 },
    { from: 'Haridwar', to: 'Pathankot', price: 7000 },
    { from: 'Haridwar', to: 'Dharamshala', price: 7500 },
    { from: 'Haridwar', to: 'Jammu', price: 8000 }]

  },
  'chandigarh-chardham': {
    from: 'Chandigarh',
    to: 'Char Dham',
    distance: '450 KM',
    duration: '10-12 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Maruti Dzire',
      type: 'Car Type',
      seats: 4,
      luggage: 3,
      price: 12500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_156e9743f-1768362507117.png",
      imageAlt: 'White Maruti Dzire sedan car for Chandigarh to Char Dham route'
    },
    {
      id: 2,
      name: 'Brezza',
      type: 'Car Type',
      seats: 4,
      luggage: 4,
      price: 15000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ee6c2ff0-1768328894687.png",
      imageAlt: 'Maruti Brezza SUV for Chandigarh to Char Dham route'
    },
    {
      id: 3,
      name: 'Maruti Ertiga',
      type: 'Car Type',
      seats: 6,
      luggage: 4,
      price: 16500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1be7fa069-1768328894291.png",
      imageAlt: 'Maruti Ertiga MPV for Chandigarh to Char Dham route'
    },
    {
      id: 4,
      name: 'Kia Carens',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 19000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1505ca721-1768380111459.png",
      imageAlt: 'Kia Carens premium MPV for Chandigarh to Char Dham route'
    },
    {
      id: 5,
      name: 'Innova Crysta',
      type: 'Car Type',
      seats: 6,
      luggage: 6,
      price: 21500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18a023f32-1768360986331.png",
      imageAlt: 'Toyota Innova Crysta for Chandigarh to Char Dham route'
    },
    {
      id: 6,
      name: 'Innova Crysta 7+1',
      type: 'Car Type',
      seats: 7,
      luggage: 6,
      price: 22600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
      imageAlt: 'Toyota Innova Crysta 7+1 seater for Chandigarh to Char Dham route'
    },
    {
      id: 7,
      name: 'Innova Hycross',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 26500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
      imageAlt: 'Toyota Innova Hycross premium for Chandigarh to Char Dham route'
    }],

    visitorsGuide: {
      intro: 'Chandigarh to Char Dham yatra package with Advait Tour and Travels. Complete pilgrimage tour.',
      sections: [
      {
        title: 'Char Dham Yatra Package',
        content: 'Visit Yamunotri, Gangotri, Kedarnath, and Badrinath with our comprehensive packages.'
      }]
    },
    faqs: [
    { question: 'What is the Chandigarh to Char Dham tour package fare?', answer: 'Tour packages start at ₹25000 with accommodation and sightseeing.' }],

    popularRoutesFrom: [
    { from: 'Chandigarh', to: 'Char Dham', price: 12500 },
    { from: 'Chandigarh', to: 'Delhi', price: 3200 },
    { from: 'Chandigarh', to: 'Shimla', price: 2500 }],

    popularRoutesTo: [
    { from: 'Char Dham', to: 'Chandigarh', price: 12500 },
    { from: 'Char Dham', to: 'Delhi', price: 6000 }]
  },

  'chandigarh-jaipur': {
    from: 'Chandigarh',
    to: 'Jaipur',
    distance: '520 KM',
    duration: '8-9 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Maruti Dzire',
      type: 'Car Type',
      seats: 4,
      luggage: 3,
      price: 6000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18a023f32-1768360986331.png",
      imageAlt: 'White Maruti Dzire sedan car for Chandigarh to Jaipur route'
    },
    {
      id: 2,
      name: 'Brezza',
      type: 'Car Type',
      seats: 4,
      luggage: 4,
      price: 7200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10b72f818-1768380109526.png",
      imageAlt: 'Maruti Brezza SUV for Chandigarh to Jaipur route'
    },
    {
      id: 3,
      name: 'Maruti Ertiga',
      type: 'Car Type',
      seats: 6,
      luggage: 4,
      price: 7900,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1be7fa069-1768328894291.png",
      imageAlt: 'Maruti Ertiga MPV for Chandigarh to Jaipur route'
    },
    {
      id: 4,
      name: 'Kia Carens',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 9100,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18a023f32-1768360986331.png",
      imageAlt: 'Kia Carens premium MPV for Chandigarh to Jaipur route'
    },
    {
      id: 5,
      name: 'Innova Crysta',
      type: 'Car Type',
      seats: 6,
      luggage: 6,
      price: 10300,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
      imageAlt: 'Toyota Innova Crysta for Chandigarh to Jaipur route'
    },
    {
      id: 6,
      name: 'Innova Crysta 7+1',
      type: 'Car Type',
      seats: 7,
      luggage: 6,
      price: 10800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ee6c2ff0-1768328894687.png",
      imageAlt: 'Toyota Innova Crysta 7+1 seater for Chandigarh to Jaipur route'
    },
    {
      id: 7,
      name: 'Innova Hycross',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 12700,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_179ca4a8c-1768360986311.png",
      imageAlt: 'Toyota Innova Hycross premium for Chandigarh to Jaipur route'
    }],

    visitorsGuide: {
      intro: 'Chandigarh to Jaipur is 520 KM. Explore the Pink City with Advait Tour and Travels.',
      sections: [
      {
        title: 'Jaipur TourPackage',
        content: 'Visit Hawa Mahal, Amber Fort, City Palace with our tour packages.'
      }]
    },
    faqs: [
    { question: 'What is the Chandigarh to Jaipur tour package fare?', answer: 'Tour packages start at ₹12000 with accommodation and sightseeing.' }],

    popularRoutesFrom: [
    { from: 'Chandigarh', to: 'Jaipur', price: 6000 },
    { from: 'Chandigarh', to: 'Delhi', price: 3200 },
    { from: 'Chandigarh', to: 'Shimla', price: 2500 }],

    popularRoutesTo: [
    { from: 'Jaipur', to: 'Chandigarh', price: 6000 },
    { from: 'Jaipur', to: 'Delhi', price: 6000 }]
  },

  'chandigarh-chardham': {
    from: 'Chandigarh',
    to: 'Vaishno Devi',
    distance: '320 KM',
    duration: '7-8 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Maruti Dzire',
      type: 'Car Type',
      seats: 4,
      luggage: 3,
      price: 5000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_179ca4a8c-1768360986311.png",
      imageAlt: 'Maruti Dzire for Chandigarh to Vaishno Devi route'
    },
    {
      id: 2,
      name: 'Brezza',
      type: 'Car Type',
      seats: 4,
      luggage: 4,
      price: 6000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ee6c2ff0-1768328894687.png",
      imageAlt: 'Brezza for Chandigarh to Vaishno Devi route'
    },
    {
      id: 3,
      name: 'Maruti Ertiga',
      type: 'Car Type',
      seats: 6,
      luggage: 4,
      price: 6600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d879e86e-1768360986352.png",
      imageAlt: 'Maruti Ertiga for Chandigarh to Vaishno Devi route'
    },
    {
      id: 4,
      name: 'Kia Carens',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 7600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ee6c2ff0-1768328894687.png",
      imageAlt: 'Kia Carens for Chandigarh to Vaishno Devi route'
    },
    {
      id: 5,
      name: 'Innova Crysta',
      type: 'Car Type',
      seats: 6,
      luggage: 6,
      price: 8600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18a023f32-1768360986331.png",
      imageAlt: 'Innova Crysta for Chandigarh to Vaishno Devi route'
    },
    {
      id: 6,
      name: 'Innova Crysta 7+1',
      type: 'Car Type',
      seats: 7,
      luggage: 6,
      price: 9000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
      imageAlt: 'Innova Crysta 7+1 for Chandigarh to Vaishno Devi route'
    },
    {
      id: 7,
      name: 'Innova Hycross',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 10600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_152c5a234-1768362508795.png",
      imageAlt: 'Innova Hycross for Chandigarh to Vaishno Devi route'
    }],

    visitorsGuide: {
      intro: 'Chandigarh to Vaishno Devi is 320 KM. Book your pilgrimage tour with Advait Tour and Travels.',
      sections: [
      {
        title: 'Vaishno Devi Yatra Package',
        content: 'Complete pilgrimage package with accommodation and darshan arrangements.'
      }]
    },
    faqs: [
    { question: 'What is the Chandigarh to Vaishno Devi tour package fare?', answer: 'Tour packages start at ₹10000 with accommodation and darshan arrangements.' }],

    popularRoutesFrom: [
    { from: 'Chandigarh', to: 'Vaishno Devi', price: 5000 },
    { from: 'Chandigarh', to: 'Delhi', price: 3200 },
    { from: 'Chandigarh', to: 'Shimla', price: 2500 }],

    popularRoutesTo: [
    { from: 'Vaishno Devi', to: 'Chandigarh', price: 5000 },
    { from: 'Vaishno Devi', to: 'Delhi', price: 6000 }]
  },

  'chandigarh-shimla': {
    from: 'Chandigarh',
    to: 'Shimla',
    distance: '115 KM',
    duration: '3-4 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Maruti Dzire',
      type: 'Car Type',
      seats: 4,
      luggage: 3,
      price: 2500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_179ca4a8c-1768360986311.png",
      imageAlt: 'White Maruti Dzire sedan car for Chandigarh to Shimla route'
    },
    {
      id: 2,
      name: 'Brezza',
      type: 'Car Type',
      seats: 4,
      luggage: 4,
      price: 3200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10b72f818-1768380109526.png",
      imageAlt: 'Maruti Brezza SUV for Chandigarh to Shimla route'
    },
    {
      id: 3,
      name: 'Maruti Ertiga',
      type: 'Car Type',
      seats: 6,
      luggage: 4,
      price: 3500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cecda4a3-1768145557954.png",
      imageAlt: 'Maruti Ertiga for Chandigarh to Shimla route'
    },
    {
      id: 4,
      name: 'Innova Crysta',
      type: 'Car Type',
      seats: 6,
      luggage: 6,
      price: 4500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_144916ecb-1768328894297.png",
      imageAlt: 'Innova Crysta for Chandigarh to Shimla route'
    }],

    visitorsGuide: {
      intro: 'Chandigarh to Shimla 115 KM, a scenic journey through the beautiful hills of Himachal Pradesh. Book our reliable taxi services with Advait Tour and Travels for a comfortable and memorable trip. Choose from a wide range of vehicles including Maruti Dzire, Brezza, Maruti Ertiga, Kia Carens, Toyota Innova Crysta, and more. All rates are inclusive of taxes with no hidden charges.',
      sections: [
      {
        title: 'Your Trusted Partner for Chandigarh to Shimla One-Way Taxi Services',
        content: 'Experience the beauty of Shimla with Advait Tour and Travels. Our one-way taxi services from Chandigarh to Shimla offer comfort, safety, and affordability for your hill station journey.'
      },
      {
        title: 'Why Choose Advait Tour and Travels?',
        content: 'We provide professional drivers, well-maintained vehicles, and transparent pricing for your Chandigarh to Shimla trip. Enjoy the scenic mountain roads with complete peace of mind.'
      }]
    },
    faqs: [
    { question: 'What is the Chandigarh to Shimla tour package fare?', answer: 'Tour packages start at ₹9000 with accommodation and sightseeing.' }],

    popularRoutesFrom: [
    { from: 'Chandigarh', to: 'Shimla', price: 2500 },
    { from: 'Chandigarh', to: 'Delhi', price: 3200 },
    { from: 'Chandigarh', to: 'Ludhiana', price: 2200 }],

    popularRoutesTo: [
    { from: 'Shimla', to: 'Chandigarh', price: 2500 },
    { from: 'Shimla', to: 'Delhi', price: 4500 },
    { from: 'Shimla', to: 'Ludhiana', price: 2500 }]
  },

  'delhi-chandigarh': {
    from: 'Delhi',
    to: 'Chandigarh',
    distance: '250 KM',
    duration: '4-5 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Maruti Dzire',
      type: 'Car Type',
      seats: 4,
      luggage: 3,
      price: 3200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_179ca4a8c-1768360986311.png",
      imageAlt: 'White Maruti Dzire sedan car for Delhi to Chandigarh route'
    },
    {
      id: 2,
      name: 'Brezza',
      type: 'Car Type',
      seats: 4,
      luggage: 4,
      price: 4200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18c52c19a-1768380107781.png",
      imageAlt: 'Maruti Brezza SUV for Delhi to Chandigarh route'
    },
    {
      id: 3,
      name: 'Maruti Ertiga',
      type: 'Car Type',
      seats: 6,
      luggage: 4,
      price: 4600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cecda4a3-1768145557954.png",
      imageAlt: 'Maruti Ertiga MPV for Delhi to Chandigarh route'
    },
    {
      id: 4,
      name: 'Kia Carens',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 5300,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ce9df03d-1768360986196.png",
      imageAlt: 'Kia Carens premium MPV for Delhi to Chandigarh route'
    },
    {
      id: 5,
      name: 'Innova Crysta',
      type: 'Car Type',
      seats: 6,
      luggage: 6,
      price: 6000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18a023f32-1768360986331.png",
      imageAlt: 'Toyota Innova Crysta for Delhi to Chandigarh route'
    },
    {
      id: 6,
      name: 'Innova Crysta 7+1',
      type: 'Car Type',
      seats: 7,
      luggage: 6,
      price: 6300,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18a023f32-1768360986331.png",
      imageAlt: 'Toyota Innova Crysta 7+1 seater for Delhi to Chandigarh route'
    },
    {
      id: 7,
      name: 'Innova Hycross',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 7400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_179ca4a8c-1768360986311.png",
      imageAlt: 'Toyota Innova Hycross premium for Delhi to Chandigarh route'
    }],

    visitorsGuide: {
      intro: 'Delhi to Chandigarh 250 KM, travel in comfort with Advait Tour and Travels. Our reliable one-way taxi services ensure a safe and pleasant journey to the City Beautiful. Choose from our fleet of well-maintained vehicles with transparent pricing.',
      sections: [
      {
        title: 'Premium Delhi to Chandigarh One-Way Taxi Services',
        content: 'Book your one-way taxi from Delhi to Chandigarh with Advait Tour and Travels. We offer comfortable vehicles, professional drivers, and competitive rates for your journey.'
      },
      {
        title: 'Why Travel with Us?',
        content: 'Experience hassle-free travel with our punctual service, clean vehicles, and experienced drivers who know the route well. All our rates are inclusive of taxes with no hidden charges.'
      }]
    },
    faqs: [
    { question: 'What is the distance from Delhi to Chandigarh?', answer: 'The distance is approximately 250 KM and takes 4-5 hours.' },
    { question: 'What vehicles are available?', answer: 'We offer Maruti Dzire, Brezza, Ertiga, Kia Carens, Innova Crysta, and more.' },
    { question: 'Are the rates inclusive of taxes?', answer: 'Yes, all our rates are inclusive of taxes with no hidden charges.' }],

    popularRoutes: [
    { from: 'Delhi', to: 'Ludhiana', distance: '310 KM' },
    { from: 'Delhi', to: 'Amritsar', distance: '450 KM' },
    { from: 'Delhi', to: 'Shimla', distance: '350 KM' }]

  },
  'chandigarh-amritsar': {
    from: 'Chandigarh',
    to: 'Amritsar',
    distance: '450 KM',
    duration: '7-8 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Maruti Dzire',
      type: 'Car Type',
      seats: 4,
      luggage: 3,
      price: 12500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
      imageAlt: 'White Maruti Dzire sedan car for Chandigarh to Amritsar route'
    },
    {
      id: 2,
      name: 'Brezza',
      type: 'Car Type',
      seats: 4,
      luggage: 4,
      price: 15000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ee6c2ff0-1768328894687.png",
      imageAlt: 'Maruti Brezza SUV for Chandigarh to Amritsar route'
    },
    {
      id: 3,
      name: 'Maruti Ertiga',
      type: 'Car Type',
      seats: 6,
      luggage: 4,
      price: 16500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_109a9f6bf-1768379759524.png",
      imageAlt: 'Maruti Ertiga MPV for Chandigarh to Amritsar route'
    },
    {
      id: 4,
      name: 'Kia Carens',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 19000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a3a6ed08-1768371331213.png",
      imageAlt: 'Kia Carens premium MPV for Chandigarh to Amritsar route'
    },
    {
      id: 5,
      name: 'Innova Crysta',
      type: 'Car Type',
      seats: 6,
      luggage: 6,
      price: 21500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18a023f32-1768360986331.png",
      imageAlt: 'Toyota Innova Crysta for Chandigarh to Amritsar route'
    },
    {
      id: 6,
      name: 'Innova Crysta 7+1',
      type: 'Car Type',
      seats: 7,
      luggage: 6,
      price: 22600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_179ca4a8c-1768360986311.png",
      imageAlt: 'Toyota Innova Crysta 7+1 seater for Chandigarh to Amritsar route'
    },
    {
      id: 7,
      name: 'Innova Hycross',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 26500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1acb0ec21-1768368473469.png",
      imageAlt: 'Toyota Innova Hycross premium for Chandigarh to Amritsar route'
    }],

    visitorsGuide: {
      intro: 'Chandigarh to Amritsar 450 KM, visit the holy Golden Temple with Advait Tour and Travels. Our comfortable one-way taxi services provide a safe and pleasant journey to the spiritual city of Amritsar.',
      sections: [
      {
        title: 'Reliable Chandigarh to Amritsar One-Way Taxi Services',
        content: 'Travel to Amritsar for Golden Temple darshan with our professional taxi services. We offer comfortable vehicles and experienced drivers for your pilgrimage journey.'
      },
      {
        title: 'Comfortable Journey to the Holy City',
        content: 'Experience a smooth ride with our well-maintained fleet. All our rates are transparent with no hidden charges, ensuring a worry-free travel experience.'
      }]
    },
    faqs: [
    { question: 'What is the distance from Chandigarh to Amritsar?', answer: 'The distance is approximately 450 KM and takes 7-8 hours.' },
    { question: 'What vehicles are available?', answer: 'We offer Maruti Dzire, Brezza, Ertiga, Kia Carens, Innova Crysta, and more.' },
    { question: 'Can I visit Wagah Border?', answer: 'Yes, you can request stops at Wagah Border and other attractions.' }],

    popularRoutesFrom: [
    { from: 'Chandigarh', to: 'Amritsar', price: 12500 },
    { from: 'Chandigarh', to: 'Delhi', price: 3200 },
    { from: 'Chandigarh', to: 'Shimla', price: 2500 }],

    popularRoutesTo: [
    { from: 'Amritsar', to: 'Chandigarh', price: 12500 },
    { from: 'Amritsar', to: 'Delhi', price: 6000 }]
  },

  'chandigarh-mussoorie': {
    from: 'Chandigarh',
    to: 'Mussoorie',
    distance: '170 KM',
    duration: '4-5 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Maruti Dzire',
      type: 'Car Type',
      seats: 4,
      luggage: 3,
      price: 3500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
      imageAlt: 'White Maruti Dzire sedan car for Chandigarh to Mussoorie route'
    },
    {
      id: 2,
      name: 'Brezza',
      type: 'Car Type',
      seats: 4,
      luggage: 4,
      price: 4200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_191a16012-1768368473200.png",
      imageAlt: 'Maruti Brezza SUV for Chandigarh to Mussoorie route'
    },
    {
      id: 3,
      name: 'Maruti Ertiga',
      type: 'Car Type',
      seats: 6,
      luggage: 4,
      price: 4600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cd87ac3f-1768362508670.png",
      imageAlt: 'Maruti Ertiga for Chandigarh to Mussoorie route'
    },
    {
      id: 4,
      name: 'Kia Carens',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 5300,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ce9df03d-1768360986196.png",
      imageAlt: 'Kia Carens for Chandigarh to Mussoorie route'
    },
    {
      id: 5,
      name: 'Innova Crysta',
      type: 'Car Type',
      seats: 6,
      luggage: 6,
      price: 6000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18a023f32-1768360986331.png",
      imageAlt: 'Innova Crysta for Chandigarh to Mussoorie route'
    },
    {
      id: 6,
      name: 'Innova Crysta 7+1',
      type: 'Car Type',
      seats: 7,
      luggage: 6,
      price: 6800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18a023f32-1768360986331.png",
      imageAlt: 'Innova Crysta 7+1 for Chandigarh to Mussoorie route'
    },
    {
      id: 7,
      name: 'Innova Hycross',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 7400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18a023f32-1768360986331.png",
      imageAlt: 'Innova Hycross for Chandigarh to Mussoorie route'
    }],

    visitorsGuide: {
      intro: 'Chandigarh to Mussoorie is 170 KM. Enjoy the Queen of Hills with Advait Tour and Travels tour packages.',
      sections: [
      {
        title: 'Mussoorie TourPackage',
        content: 'Visit Kempty Falls and Mall Road with our tour packages.'
      }]
    },
    faqs: [
    { question: 'What is the Chandigarh to Mussoorie tour package fare?', answer: 'Tour packages start at ₹7000 with accommodation and sightseeing.' }],

    popularRoutesFrom: [
    { from: 'Chandigarh', to: 'Mussoorie', price: 3500 },
    { from: 'Chandigarh', to: 'Delhi', price: 3200 },
    { from: 'Chandigarh', to: 'Shimla', price: 2500 }],

    popularRoutesTo: [
    { from: 'Mussoorie', to: 'Chandigarh', price: 3500 },
    { from: 'Mussoorie', to: 'Delhi', price: 6000 }]
  },

  'chandigarh-himachal': {
    from: 'Chandigarh',
    to: 'Himachal Pradesh',
    distance: '250 KM',
    duration: '6-7 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Maruti Dzire',
      type: 'Car Type',
      seats: 4,
      luggage: 3,
      price: 3500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
      imageAlt: 'Maruti Dzire for Chandigarh to Himachal tour'
    },
    {
      id: 2,
      name: 'Brezza',
      type: 'Car Type',
      seats: 4,
      luggage: 4,
      price: 4200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ee6c2ff0-1768328894687.png",
      imageAlt: 'Brezza for Chandigarh to Himachal tour'
    },
    {
      id: 3,
      name: 'Maruti Ertiga',
      type: 'Car Type',
      seats: 6,
      luggage: 4,
      price: 4600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16b725c90-1768360984929.png",
      imageAlt: 'Maruti Ertiga for Chandigarh to Himachal tour'
    },
    {
      id: 4,
      name: 'Kia Carens',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 5300,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ce9df03d-1768360986196.png",
      imageAlt: 'Kia Carens for Chandigarh to Himachal tour'
    },
    {
      id: 5,
      name: 'Innova Crysta',
      type: 'Car Type',
      seats: 6,
      luggage: 6,
      price: 6000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18a023f32-1768360986331.png",
      imageAlt: 'Innova Crysta for Chandigarh to Himachal tour'
    },
    {
      id: 6,
      name: 'Innova Crysta 7+1',
      type: 'Car Type',
      seats: 7,
      luggage: 6,
      price: 6300,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18a023f32-1768360986331.png",
      imageAlt: 'Innova Crysta 7+1 for Chandigarh to Himachal tour'
    },
    {
      id: 7,
      name: 'Innova Hycross',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 7400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18a023f32-1768360986331.png",
      imageAlt: 'Innova Hycross for Chandigarh to Himachal tour'
    }],

    visitorsGuide: {
      intro: 'Explore Himachal Pradesh from Chandigarh with Advait Tour and Travels tour packages.',
      sections: [
      {
        title: 'Himachal TourPackage',
        content: 'Visit multiple destinations in Himachal with our customized tour packages.'
      }]
    },
    faqs: [
    { question: 'What is the Chandigarh to Himachal tour package fare?', answer: 'Tour packages start at ₹7000 with accommodation and sightseeing.' }],

    popularRoutesFrom: [
    { from: 'Chandigarh', to: 'Himachal Pradesh', price: 3500 },
    { from: 'Chandigarh', to: 'Delhi', price: 3200 },
    { from: 'Chandigarh', to: 'Shimla', price: 2500 }],

    popularRoutesTo: [
    { from: 'Himachal Pradesh', to: 'Chandigarh', price: 3500 },
    { from: 'Himachal Pradesh', to: 'Delhi', price: 6000 }]
  },

  'chandigarh-agra': {
    from: 'Chandigarh',
    to: 'Agra',
    distance: '420 KM',
    duration: '7-8 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Maruti Dzire',
      type: 'Car Type',
      seats: 4,
      luggage: 3,
      price: 6000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
      imageAlt: 'Maruti Dzire for Chandigarh to Agra tour'
    },
    {
      id: 2,
      name: 'Brezza',
      type: 'Car Type',
      seats: 4,
      luggage: 4,
      price: 7200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18a023f32-1768360986331.png",
      imageAlt: 'Brezza for Chandigarh to Agra tour'
    },
    {
      id: 3,
      name: 'Maruti Ertiga',
      type: 'Car Type',
      seats: 6,
      luggage: 4,
      price: 7900,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_179ca4a8c-1768360986311.png",
      imageAlt: 'Maruti Ertiga for Chandigarh to Agra tour'
    },
    {
      id: 4,
      name: 'Kia Carens',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 9100,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ce9df03d-1768360986196.png",
      imageAlt: 'Kia Carens for Chandigarh to Agra tour'
    },
    {
      id: 5,
      name: 'Innova Crysta',
      type: 'Car Type',
      seats: 6,
      luggage: 6,
      price: 10300,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18a023f32-1768360986331.png",
      imageAlt: 'Innova Crysta for Chandigarh to Agra tour'
    },
    {
      id: 6,
      name: 'Innova Crysta 7+1',
      type: 'Car Type',
      seats: 7,
      luggage: 6,
      price: 10800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18a023f32-1768360986331.png",
      imageAlt: 'Innova Crysta 7+1 for Chandigarh to Agra tour'
    },
    {
      id: 7,
      name: 'Innova Hycross',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 12700,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_179ca4a8c-1768360986311.png",
      imageAlt: 'Innova Hycross for Chandigarh to Agra tour'
    }],

    visitorsGuide: {
      intro: 'Chandigarh to Agra is 420 KM. Visit the iconic Taj Mahal with Advait Tour and Travels.',
      sections: [
      {
        title: 'Agra TourPackage',
        content: 'Explore Taj Mahal, Agra Fort, and Fatehpur Sikri with our tour packages.'
      }]
    },
    faqs: [
    { question: 'What is the Chandigarh to Agra tour package fare?', answer: 'Tour packages start at ₹12000 with accommodation and sightseeing.' }],

    popularRoutesFrom: [
    { from: 'Chandigarh', to: 'Agra', price: 6000 },
    { from: 'Chandigarh', to: 'Delhi', price: 3200 },
    { from: 'Chandigarh', to: 'Shimla', price: 2500 }],

    popularRoutesTo: [
    { from: 'Agra', to: 'Chandigarh', price: 6000 },
    { from: 'Agra', to: 'Delhi', price: 6000 }]
  },

  'chandigarh-chardham': {
    from: 'Chandigarh',
    to: 'Char Dham',
    distance: '450 KM',
    duration: '10-12 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Maruti Dzire',
      type: 'Car Type',
      seats: 4,
      luggage: 3,
      price: 12500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
      imageAlt: 'Maruti Dzire for Chandigarh to Char Dham tour'
    },
    {
      id: 2,
      name: 'Brezza',
      type: 'Car Type',
      seats: 4,
      luggage: 4,
      price: 15000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_179ca4a8c-1768360986311.png",
      imageAlt: 'Brezza for Chandigarh to Char Dham tour'
    },
    {
      id: 3,
      name: 'Maruti Ertiga',
      type: 'Car Type',
      seats: 6,
      luggage: 4,
      price: 16500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1830ab5d0-1768360986295.png",
      imageAlt: 'Maruti Ertiga for Chandigarh to Char Dham tour'
    },
    {
      id: 4,
      name: 'Kia Carens',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 19000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ce9df03d-1768360986196.png",
      imageAlt: 'Kia Carens for Chandigarh to Char Dham tour'
    },
    {
      id: 5,
      name: 'Innova Crysta',
      type: 'Car Type',
      seats: 6,
      luggage: 6,
      price: 21500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
      imageAlt: 'Innova Crysta for Chandigarh to Char Dham tour'
    },
    {
      id: 6,
      name: 'Innova Crysta 7+1',
      type: 'Car Type',
      seats: 7,
      luggage: 6,
      price: 22600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18a023f32-1768360986331.png",
      imageAlt: 'Innova Crysta 7+1 for Chandigarh to Char Dham tour'
    },
    {
      id: 7,
      name: 'Innova Hycross',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 26500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16b725c90-1768360984929.png",
      imageAlt: 'Innova Hycross for Chandigarh to Char Dham tour'
    }],

    visitorsGuide: {
      intro: 'Chandigarh to Char Dham yatra package with Advait Tour and Travels. Complete pilgrimage tour.',
      sections: [
      {
        title: 'Char Dham Yatra Package',
        content: 'Visit Yamunotri, Gangotri, Kedarnath, and Badrinath with our comprehensive packages.'
      }]
    },
    faqs: [
    { question: 'What is the Chandigarh to Char Dham tour package fare?', answer: 'Tour packages start at ₹25000 with accommodation and sightseeing.' }],

    popularRoutesFrom: [
    { from: 'Chandigarh', to: 'Char Dham', price: 12500 },
    { from: 'Chandigarh', to: 'Delhi', price: 3200 },
    { from: 'Chandigarh', to: 'Shimla', price: 2500 }],

    popularRoutesTo: [
    { from: 'Char Dham', to: 'Chandigarh', price: 12500 },
    { from: 'Char Dham', to: 'Delhi', price: 6000 }]
  },

  'chandigarh-chardham': {
    from: 'Chandigarh',
    to: 'Vaishno Devi',
    distance: '320 KM',
    duration: '7-8 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Maruti Dzire',
      type: 'Car Type',
      seats: 4,
      luggage: 3,
      price: 5000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
      imageAlt: 'Maruti Dzire for Chandigarh to Vaishno Devi route'
    },
    {
      id: 2,
      name: 'Brezza',
      type: 'Car Type',
      seats: 4,
      luggage: 4,
      price: 6000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ee6c2ff0-1768328894687.png",
      imageAlt: 'Brezza for Chandigarh to Vaishno Devi route'
    },
    {
      id: 3,
      name: 'Maruti Ertiga',
      type: 'Car Type',
      seats: 6,
      luggage: 4,
      price: 6600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_179ca4a8c-1768360986311.png",
      imageAlt: 'Maruti Ertiga for Chandigarh to Vaishno Devi route'
    },
    {
      id: 4,
      name: 'Kia Carens',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 7600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18a023f32-1768360986331.png",
      imageAlt: 'Kia Carens for Chandigarh to Vaishno Devi route'
    },
    {
      id: 5,
      name: 'Innova Crysta',
      type: 'Car Type',
      seats: 6,
      luggage: 6,
      price: 8600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18a023f32-1768360986331.png",
      imageAlt: 'Innova Crysta for Chandigarh to Vaishno Devi route'
    },
    {
      id: 6,
      name: 'Innova Crysta 7+1',
      type: 'Car Type',
      seats: 7,
      luggage: 6,
      price: 9000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
      imageAlt: 'Innova Crysta 7+1 for Chandigarh to Vaishno Devi route'
    },
    {
      id: 7,
      name: 'Innova Hycross',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 10600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18a023f32-1768360986331.png",
      imageAlt: 'Innova Hycross for Chandigarh to Vaishno Devi route'
    }],

    visitorsGuide: {
      intro: 'Chandigarh to Vaishno Devi is 320 KM. Book your pilgrimage tour with Advait Tour and Travels.',
      sections: [
      {
        title: 'Vaishno Devi Yatra Package',
        content: 'Complete pilgrimage package with accommodation and darshan arrangements.'
      }]
    },
    faqs: [
    { question: 'What is the Chandigarh to Vaishno Devi tour package fare?', answer: 'Tour packages start at ₹10000 with accommodation and darshan arrangements.' }],

    popularRoutesFrom: [
    { from: 'Chandigarh', to: 'Vaishno Devi', price: 5000 },
    { from: 'Chandigarh', to: 'Delhi', price: 3200 },
    { from: 'Chandigarh', to: 'Shimla', price: 2500 }],

    popularRoutesTo: [
    { from: 'Vaishno Devi', to: 'Chandigarh', price: 5000 },
    { from: 'Vaishno Devi', to: 'Delhi', price: 6000 }]
  },

  'chandigarh-shimla': {
    from: 'Chandigarh',
    to: 'Shimla',
    distance: '115 KM',
    duration: '3-4 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Maruti Dzire',
      type: 'Car Type',
      seats: 4,
      luggage: 3,
      price: 2500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_179ca4a8c-1768360986311.png",
      imageAlt: 'White Maruti Dzire sedan car for Chandigarh to Shimla route'
    },
    {
      id: 2,
      name: 'Brezza',
      type: 'Car Type',
      seats: 4,
      luggage: 4,
      price: 3200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b2006110-1768379490868.png",
      imageAlt: 'Maruti Brezza SUV for Chandigarh to Shimla route'
    },
    {
      id: 3,
      name: 'Maruti Ertiga',
      type: 'Car Type',
      seats: 6,
      luggage: 4,
      price: 3500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cecda4a3-1768145557954.png",
      imageAlt: 'Maruti Ertiga MPV for Chandigarh to Shimla route'
    },
    {
      id: 4,
      name: 'Innova Crysta',
      type: 'Car Type',
      seats: 6,
      luggage: 6,
      price: 4500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_144916ecb-1768328894297.png",
      imageAlt: 'Toyota Innova Crysta for Chandigarh to Shimla route'
    }],

    visitorsGuide: {
      intro: 'Chandigarh to Shimla 115 KM, a scenic journey through the beautiful hills of Himachal Pradesh. Book our reliable taxi services with Advait Tour and Travels for a comfortable and memorable trip. Choose from a wide range of vehicles including Maruti Dzire, Brezza, Maruti Ertiga, Kia Carens, Toyota Innova Crysta, and more. All rates are inclusive of taxes with no hidden charges.',
      sections: [
      {
        title: 'Your Trusted Partner for Chandigarh to Shimla One-Way Taxi Services',
        content: 'Experience the beauty of Shimla with Advait Tour and Travels. Our one-way taxi services from Chandigarh to Shimla offer comfort, safety, and affordability for your hill station journey.'
      },
      {
        title: 'Why Choose Advait Tour and Travels?',
        content: 'We provide professional drivers, well-maintained vehicles, and transparent pricing for your Chandigarh to Shimla trip. Enjoy the scenic mountain roads with complete peace of mind.'
      }]
    },
    faqs: [
    { question: 'What is the Chandigarh to Shimla tour package fare?', answer: 'Tour packages start at ₹9000 with accommodation and sightseeing.' }],

    popularRoutesFrom: [
    { from: 'Chandigarh', to: 'Shimla', price: 2500 },
    { from: 'Chandigarh', to: 'Delhi', price: 3200 },
    { from: 'Chandigarh', to: 'Ludhiana', price: 2200 }],

    popularRoutesTo: [
    { from: 'Shimla', to: 'Chandigarh', price: 2500 },
    { from: 'Shimla', to: 'Delhi', price: 4500 },
    { from: 'Shimla', to: 'Ludhiana', price: 2500 }]
  },

  'delhi-chandigarh': {
    from: 'Delhi',
    to: 'Chandigarh',
    distance: '250 KM',
    duration: '4-5 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Maruti Dzire',
      type: 'Car Type',
      seats: 4,
      luggage: 3,
      price: 3200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_152c5a234-1768362508795.png",
      imageAlt: 'White Maruti Dzire sedan car for Delhi to Chandigarh route'
    },
    {
      id: 2,
      name: 'Brezza',
      type: 'Car Type',
      seats: 4,
      luggage: 4,
      price: 4200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18a023f32-1768360986331.png",
      imageAlt: 'Maruti Brezza SUV for Delhi to Chandigarh route'
    },
    {
      id: 3,
      name: 'Maruti Ertiga',
      type: 'Car Type',
      seats: 6,
      luggage: 4,
      price: 4600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d879e86e-1768360986352.png",
      imageAlt: 'Maruti Ertiga MPV for Delhi to Chandigarh route'
    },
    {
      id: 4,
      name: 'Kia Carens',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 5300,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a3a6ed08-1768371331213.png",
      imageAlt: 'Kia Carens premium MPV for Delhi to Chandigarh route'
    },
    {
      id: 5,
      name: 'Innova Crysta',
      type: 'Car Type',
      seats: 6,
      luggage: 6,
      price: 6000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18a023f32-1768360986331.png",
      imageAlt: 'Toyota Innova Crysta for Delhi to Chandigarh route'
    },
    {
      id: 6,
      name: 'Innova Crysta 7+1',
      type: 'Car Type',
      seats: 7,
      luggage: 6,
      price: 6300,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18a023f32-1768360986331.png",
      imageAlt: 'Toyota Innova Crysta 7+1 seater for Delhi to Chandigarh route'
    },
    {
      id: 7,
      name: 'Innova Hycross',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 7400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_179ca4a8c-1768360986311.png",
      imageAlt: 'Toyota Innova Hycross premium for Delhi to Chandigarh route'
    }],

    visitorsGuide: {
      intro: 'Delhi to Chandigarh 250 KM, travel in comfort with Advait Tour and Travels. Our reliable one-way taxi services ensure a safe and pleasant journey to the City Beautiful. Choose from our fleet of well-maintained vehicles with transparent pricing.',
      sections: [
      {
        title: 'Premium Delhi to Chandigarh One-Way Taxi Services',
        content: 'Book your one-way taxi from Delhi to Chandigarh with Advait Tour and Travels. We offer comfortable vehicles, professional drivers, and competitive rates for your journey.'
      },
      {
        title: 'Why Travel with Us?',
        content: 'Experience hassle-free travel with our punctual service, clean vehicles, and experienced drivers who know the route well. All our rates are inclusive of taxes with no hidden charges.'
      }]
    },
    faqs: [
    { question: 'What is the distance from Delhi to Chandigarh?', answer: 'The distance is approximately 250 KM and takes 4-5 hours.' },
    { question: 'What vehicles are available?', answer: 'We offer Maruti Dzire, Brezza, Ertiga, Kia Carens, Innova Crysta, and more.' },
    { question: 'Are the rates inclusive of taxes?', answer: 'Yes, all our rates are inclusive of taxes with no hidden charges.' }],

    popularRoutes: [
    { from: 'Delhi', to: 'Ludhiana', distance: '310 KM' },
    { from: 'Delhi', to: 'Amritsar', distance: '450 KM' },
    { from: 'Delhi', to: 'Shimla', distance: '350 KM' }]

  },
  'chandigarh-amritsar': {
    from: 'Chandigarh',
    to: 'Amritsar',
    distance: '450 KM',
    duration: '7-8 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Maruti Dzire',
      type: 'Car Type',
      seats: 4,
      luggage: 3,
      price: 12500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
      imageAlt: 'White Maruti Dzire sedan car for Chandigarh to Amritsar route'
    },
    {
      id: 2,
      name: 'Brezza',
      type: 'Car Type',
      seats: 4,
      luggage: 4,
      price: 15000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ee6c2ff0-1768328894687.png",
      imageAlt: 'Maruti Brezza SUV for Chandigarh to Amritsar route'
    },
    {
      id: 3,
      name: 'Maruti Ertiga',
      type: 'Car Type',
      seats: 6,
      luggage: 4,
      price: 16500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16b725c90-1768360984929.png",
      imageAlt: 'Maruti Ertiga MPV for Chandigarh to Amritsar route'
    },
    {
      id: 4,
      name: 'Kia Carens',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 19000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a3a6ed08-1768371331213.png",
      imageAlt: 'Kia Carens premium MPV for Chandigarh to Amritsar route'
    },
    {
      id: 5,
      name: 'Innova Crysta',
      type: 'Car Type',
      seats: 6,
      luggage: 6,
      price: 21500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18a023f32-1768360986331.png",
      imageAlt: 'Toyota Innova Crysta for Chandigarh to Amritsar route'
    },
    {
      id: 6,
      name: 'Innova Crysta 7+1',
      type: 'Car Type',
      seats: 7,
      luggage: 6,
      price: 22600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_191a16012-1768368473200.png",
      imageAlt: 'Toyota Innova Crysta 7+1 seater for Chandigarh to Amritsar route'
    },
    {
      id: 7,
      name: 'Innova Hycross',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 26500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_191a16012-1768368473200.png",
      imageAlt: 'Toyota Innova Hycross premium for Chandigarh to Amritsar route'
    }],

    visitorsGuide: {
      intro: 'Chandigarh to Amritsar 450 KM, visit the holy Golden Temple with Advait Tour and Travels. Our comfortable one-way taxi services provide a safe and pleasant journey to the spiritual city of Amritsar.',
      sections: [
      {
        title: 'Reliable Chandigarh to Amritsar One-Way Taxi Services',
        content: 'Travel to Amritsar for Golden Temple darshan with our professional taxi services. We offer comfortable vehicles and experienced drivers for your pilgrimage journey.'
      },
      {
        title: 'Comfortable Journey to the Holy City',
        content: 'Experience a smooth ride with our well-maintained fleet. All our rates are transparent with no hidden charges, ensuring a worry-free travel experience.'
      }]
    },
    faqs: [
    { question: 'What is the distance from Chandigarh to Amritsar?', answer: 'The distance is approximately 450 KM and takes 7-8 hours.' },
    { question: 'What vehicles are available?', answer: 'We offer Maruti Dzire, Brezza, Ertiga, Kia Carens, Innova Crysta, and more.' },
    { question: 'Can I visit Wagah Border?', answer: 'Yes, you can request stops at Wagah Border and other attractions.' }],

    popularRoutesFrom: [
    { from: 'Chandigarh', to: 'Amritsar', price: 12500 },
    { from: 'Chandigarh', to: 'Delhi', price: 3200 },
    { from: 'Chandigarh', to: 'Shimla', price: 2500 }],

    popularRoutesTo: [
    { from: 'Amritsar', to: 'Chandigarh', price: 12500 },
    { from: 'Amritsar', to: 'Delhi', price: 6000 }]
  },

  'chandigarh-shimla': {
    from: 'Chandigarh',
    to: 'Shimla',
    distance: '115 KM',
    duration: '3-4 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Maruti Dzire',
      type: 'Car Type',
      seats: 4,
      luggage: 3,
      price: 2500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
      imageAlt: 'White Maruti Dzire sedan car for Chandigarh to Shimla route'
    },
    {
      id: 2,
      name: 'Brezza',
      type: 'Car Type',
      seats: 4,
      luggage: 4,
      price: 3200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10b72f818-1768380109526.png",
      imageAlt: 'Maruti Brezza SUV for Chandigarh to Shimla route'
    },
    {
      id: 3,
      name: 'Maruti Ertiga',
      type: 'Car Type',
      seats: 6,
      luggage: 4,
      price: 3500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cecda4a3-1768145557954.png",
      imageAlt: 'Maruti Ertiga MPV for Chandigarh to Shimla route'
    },
    {
      id: 4,
      name: 'Innova Crysta',
      type: 'Car Type',
      seats: 6,
      luggage: 6,
      price: 4500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_144916ecb-1768328894297.png",
      imageAlt: 'Toyota Innova Crysta for Chandigarh to Shimla route'
    }],

    visitorsGuide: {
      intro: 'Chandigarh to Shimla 115 KM, a scenic journey through the beautiful hills of Himachal Pradesh. Book our reliable taxi services with Advait Tour and Travels for a comfortable and memorable trip. Choose from a wide range of vehicles including Maruti Dzire, Brezza, Maruti Ertiga, Kia Carens, Toyota Innova Crysta, and more. All rates are inclusive of taxes with no hidden charges.',
      sections: [
      {
        title: 'Your Trusted Partner for Chandigarh to Shimla One-Way Taxi Services',
        content: 'Experience the beauty of Shimla with Advait Tour and Travels. Our one-way taxi services from Chandigarh to Shimla offer comfort, safety, and affordability for your hill station journey.'
      },
      {
        title: 'Why Choose Advait Tour and Travels?',
        content: 'We provide professional drivers, well-maintained vehicles, and transparent pricing for your Chandigarh to Shimla trip. Enjoy the scenic mountain roads with complete peace of mind.'
      }]
    },
    faqs: [
    { question: 'What is the Chandigarh to Shimla tour package fare?', answer: 'Tour packages start at ₹9000 with accommodation and sightseeing.' }],

    popularRoutesFrom: [
    { from: 'Chandigarh', to: 'Shimla', price: 2500 },
    { from: 'Chandigarh', to: 'Delhi', price: 3200 },
    { from: 'Chandigarh', to: 'Ludhiana', price: 2200 }],

    popularRoutesTo: [
    { from: 'Shimla', to: 'Chandigarh', price: 2500 },
    { from: 'Shimla', to: 'Delhi', price: 4500 },
    { from: 'Shimla', to: 'Ludhiana', price: 2500 }]
  },

  'delhi-kharar': {
    from: 'Delhi',
    to: 'Kharar',
    distance: '270 KM',
    duration: '5 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Maruti Dzire',
      type: 'Car Type',
      seats: 4,
      luggage: 3,
      price: 3500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_109a9f6bf-1768379759524.png",
      imageAlt: 'White Maruti Dzire sedan car for Delhi to Kharar route'
    },
    {
      id: 2,
      name: 'Brezza',
      type: 'Car Type',
      seats: 4,
      luggage: 4,
      price: 4600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d879e86e-1768360986352.png",
      imageAlt: 'Maruti Brezza SUV for Delhi to Kharar route'
    },
    {
      id: 3,
      name: 'Maruti Ertiga',
      type: 'Car Type',
      seats: 6,
      luggage: 4,
      price: 5000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cecda4a3-1768145557954.png",
      imageAlt: 'Maruti Ertiga MPV for Delhi to Kharar route'
    },
    {
      id: 4,
      name: 'Innova Crysta',
      type: 'Car Type',
      seats: 6,
      luggage: 6,
      price: 6500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18a023f32-1768360986331.png",
      imageAlt: 'Toyota Innova Crysta for Delhi to Kharar route'
    }],

    visitorsGuide: {
      intro: 'Delhi to Kharar 270 KM, one-way cab service with Advait Tour and Travels. Enjoy a comfortable journey to Kharar with our experienced drivers.',
      sections: [
      {
        title: 'Delhi to Kharar Taxi Service',
        content: 'Travel to Kharar from Delhi with our reliable taxi service. We offer comfortable vehicles and professional drivers.'
      }]
    },
    faqs: [
    { question: 'What is the distance from Delhi to Kharar?', answer: 'The distance is approximately 270 KM and takes 5 hours.' }],

    popularRoutes: [
    { from: 'Delhi', to: 'Chandigarh', distance: '250 KM' },
    { from: 'Delhi', to: 'Ludhiana', distance: '310 KM' }]

  },
  'chandigarh-noida': {
    from: 'Chandigarh',
    to: 'Noida',
    distance: '270 KM',
    duration: '5 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Maruti Dzire',
      type: 'Car Type',
      seats: 4,
      luggage: 3,
      price: 3800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_109a9f6bf-1768379759524.png",
      imageAlt: 'White Maruti Dzire sedan car for Chandigarh to Noida route'
    },
    {
      id: 2,
      name: 'Brezza',
      type: 'Car Type',
      seats: 4,
      luggage: 4,
      price: 5000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_19d89faa6-1768370736021.png",
      imageAlt: 'Maruti Brezza SUV for Chandigarh to Noida route'
    },
    {
      id: 3,
      name: 'Maruti Ertiga',
      type: 'Car Type',
      seats: 6,
      luggage: 4,
      price: 5500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cecda4a3-1768145557954.png",
      imageAlt: 'Maruti Ertiga MPV for Chandigarh to Noida route'
    },
    {
      id: 4,
      name: 'Innova Crysta',
      type: 'Car Type',
      seats: 6,
      luggage: 6,
      price: 7000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18a023f32-1768360986331.png",
      imageAlt: 'Toyota Innova Crysta for Chandigarh to Noida route'
    }],

    visitorsGuide: {
      intro: 'Chandigarh to Noida 270 KM, premium taxi service with Advait Tour and Travels for business and leisure travelers.',
      sections: [
      {
        title: 'Chandigarh to Noida Taxi Service',
        content: 'Book your taxi from Chandigarh to Noida with us for a comfortable journey. Ideal for business trips and family travel.'
      }]
    },
    faqs: [
    { question: 'What is the distance from Chandigarh to Noida?', answer: 'The distance is approximately 270 KM and takes 5 hours.' }],

    popularRoutes: [
    { from: 'Chandigarh', to: 'Delhi', distance: '250 KM' },
    { from: 'Chandigarh', to: 'Gurgaon', distance: '265 KM' }]

  },
  'chandigarh-jammu': {
    from: 'Chandigarh',
    to: 'Jammu',
    distance: '300 KM',
    duration: '6 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Maruti Dzire',
      type: 'Car Type',
      seats: 4,
      luggage: 3,
      price: 4200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
      imageAlt: 'White Maruti Dzire sedan car for Chandigarh to Jammu route'
    },
    {
      id: 2,
      name: 'Brezza',
      type: 'Car Type',
      seats: 4,
      luggage: 4,
      price: 5500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d879e86e-1768360986352.png",
      imageAlt: 'Maruti Brezza SUV for Chandigarh to Jammu route'
    },
    {
      id: 3,
      name: 'Maruti Ertiga',
      type: 'Car Type',
      seats: 6,
      luggage: 4,
      price: 6000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cecda4a3-1768145557954.png",
      imageAlt: 'Maruti Ertiga MPV for Chandigarh to Jammu route'
    },
    {
      id: 4,
      name: 'Innova Crysta',
      type: 'Car Type',
      seats: 6,
      luggage: 6,
      price: 7500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_156e9743f-1768362507117.png",
      imageAlt: 'Toyota Innova Crysta for Chandigarh to Jammu route'
    }],

    visitorsGuide: {
      intro: 'Chandigarh to Jammu 300 KM, reliable one-way taxi service with Advait Tour and Travels for your journey to the temple city.',
      sections: [
      {
        title: 'Chandigarh to Jammu Taxi Service',
        content: 'Travel to Jammu from Chandigarh with our comfortable taxi service. Perfect for Vaishno Devi pilgrimage and Kashmir trips.'
      }]
    },
    faqs: [
    { question: 'What is the distance from Chandigarh to Jammu?', answer: 'The distance is approximately 300 KM and takes 6 hours.' }],

    popularRoutes: [
    { from: 'Chandigarh', to: 'Amritsar', distance: '230 KM' },
    { from: 'Chandigarh', to: 'Pathankot', distance: '200 KM' }]

  },
  'chandigarh-manali': {
    from: 'Chandigarh',
    to: 'Manali',
    distance: '310 KM',
    duration: '7-8 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Maruti Dzire',
      type: 'Car Type',
      seats: 4,
      luggage: 3,
      price: 4500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ac5f6034-1767621357232.png",
      imageAlt: 'White Maruti Dzire sedan car for Chandigarh to Manali route'
    },
    {
      id: 2,
      name: 'Brezza',
      type: 'Car Type',
      seats: 4,
      luggage: 4,
      price: 5900,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_19d89faa6-1768370736021.png",
      imageAlt: 'Maruti Brezza SUV for Chandigarh to Manali route'
    },
    {
      id: 3,
      name: 'Maruti Ertiga',
      type: 'Car Type',
      seats: 6,
      luggage: 4,
      price: 6500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cecda4a3-1768145557954.png",
      imageAlt: 'Maruti Ertiga MPV for Chandigarh to Manali route'
    },
    {
      id: 4,
      name: 'Innova Crysta',
      type: 'Car Type',
      seats: 6,
      luggage: 6,
      price: 8000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_156e9743f-1768362507117.png",
      imageAlt: 'Toyota Innova Crysta for Chandigarh to Manali route'
    }],

    visitorsGuide: {
      intro: 'Chandigarh to Manali 310 KM, scenic taxi journey with Advait Tour and Travels through the beautiful Himalayan valleys.',
      sections: [
      {
        title: 'Scenic Chandigarh to Manali Taxi Service',
        content: 'Experience the breathtaking journey from Chandigarh to Manali with our professional taxi service. Enjoy mountain views and comfortable travel.'
      }]
    },
    faqs: [
    { question: 'What is the distance from Chandigarh to Manali?', answer: 'The distance is approximately 310 KM and takes 7-8 hours.' },
    { question: 'Is the route safe in winter?', answer: 'Yes, our experienced drivers are familiar with mountain driving in all seasons.' }],

    popularRoutes: [
    { from: 'Chandigarh', to: 'Shimla', distance: '115 KM' },
    { from: 'Chandigarh', to: 'Dharamshala', distance: '245 KM' }]

  },

  'chandigarh-delhi': {
    from: 'Chandigarh',
    to: 'Delhi',
    distance: '250 KM',
    duration: '4-5 hours',
    companyName: 'Sardar Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Maruti Dzire',
      type: 'Car Type',
      seats: 4,
      luggage: 3,
      price: 3200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
      imageAlt: 'White Maruti Dzire sedan car for Chandigarh to Delhi route'
    },
    {
      id: 2,
      name: 'Brezza',
      type: 'Car Type',
      seats: 4,
      luggage: 4,
      price: 3800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10b72f818-1768380109526.png",
      imageAlt: 'Maruti Brezza SUV for Chandigarh to Delhi route'
    },
    {
      id: 3,
      name: 'Maruti Ertiga',
      type: 'Car Type',
      seats: 6,
      luggage: 4,
      price: 4200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cecda4a3-1768145557954.png",
      imageAlt: 'Maruti Ertiga MPV for Chandigarh to Delhi route'
    },
    {
      id: 4,
      name: 'Kia Carens',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 4800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a3a6ed08-1768371331213.png",
      imageAlt: 'Kia Carens premium MPV for Chandigarh to Delhi route'
    },
    {
      id: 5,
      name: 'Innova Crysta',
      type: 'Car Type',
      seats: 6,
      luggage: 6,
      price: 5400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_152c5a234-1768362508795.png",
      imageAlt: 'Toyota Innova Crysta for Chandigarh to Delhi route'
    },
    {
      id: 6,
      name: 'Innova Crysta 7+1',
      type: 'Car Type',
      seats: 7,
      luggage: 6,
      price: 5800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_152c5a234-1768362508795.png",
      imageAlt: 'Toyota Innova Crysta 7+1 seater for Chandigarh to Delhi route'
    },
    {
      id: 7,
      name: 'Innova Hycross',
      type: 'Car Type',
      seats: 6,
      luggage: 5,
      price: 6700,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_191a16012-1768368473200.png",
      imageAlt: 'Toyota Innova Hycross premium for Chandigarh to Delhi route'
    }],

    visitorsGuide: {
      intro: 'Chandigarh to Delhi One Way Taxi Services by Sardar Travels. Book your comfortable ride from Chandigarh to Delhi with professional drivers and well-maintained vehicles.',
      sections: [
      {
        title: 'Chandigarh to Delhi One Way Taxi Services',
        content: 'Travel from Chandigarh to Delhi in comfort with Sardar Travels. Our professional drivers ensure a safe and pleasant journey.'
      }]

    },
    faqs: [
    { question: 'What is the distance from Chandigarh to Delhi?', answer: 'The distance from Chandigarh to Delhi is approximately 250 kilometers.' },
    { question: 'How long does it take from Chandigarh to Delhi?', answer: 'It takes approximately 4-5 hours to travel from Chandigarh to Delhi by road.' },
    { question: 'What is the Chandigarh to Delhi taxi fare?', answer: 'The taxi fare from Chandigarh to Delhi starts at ₹3200 for a Maruti Dzire.' }],

    popularRoutes: [
    { name: 'Delhi to Chandigarh', slug: 'delhi-chandigarh' },
    { name: 'Chandigarh to Shimla', slug: 'chandigarh-shimla' },
    { name: 'Chandigarh to Manali', slug: 'chandigarh-manali' }]

  },

  // Force Urbania Routes
  'chandigarh-manali-urbania': {
    from: 'Chandigarh',
    to: 'Manali',
    distance: '310 KM',
    duration: '7-8 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Force Urbania',
      type: 'Vehicle Type',
      seats: 12,
      luggage: 9,
      price: 32400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: 'Force Urbania 12 seater for Chandigarh to Manali'
    },
    {
      id: 2,
      name: 'Force Urbania',
      type: 'Vehicle Type',
      seats: 16,
      luggage: 16,
      price: 35000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: 'Force Urbania 16 seater for Chandigarh to Manali'
    }],

    visitorsGuide: {
      intro: 'Chandigarh to Manali Force Urbania luxury group travel with Advait Tour and Travels.',
      sections: [
      {
        title: 'Manali Luxury Group Tour',
        content: 'Travel in luxury Force Urbania to Manali hill station.'
      }]
    },
    faqs: [
    { question: 'What is the Chandigarh to Manali Force Urbania fare?', answer: 'Force Urbania fare starts at ₹32400 for 12 seater.' }],

    popularRoutesFrom: [
    { from: 'Chandigarh', to: 'Manali', price: 32400 },
    { from: 'Chandigarh', to: 'Delhi', price: 14000 },
    { from: 'Chandigarh', to: 'Shimla', price: 2500 }],

    popularRoutesTo: [
    { from: 'Manali', to: 'Chandigarh', price: 32400 },
    { from: 'Manali', to: 'Delhi', price: 32400 },
    { from: 'Manali', to: 'Shimla', price: 32400 }]
  },

  'chandigarh-shimla-urbania': {
    from: 'Chandigarh',
    to: 'Shimla',
    distance: '115 KM',
    duration: '3-4 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Force Urbania',
      type: 'Vehicle Type',
      seats: 12,
      luggage: 9,
      price: 13000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: 'Force Urbania 12 seater for Chandigarh to Shimla'
    },
    {
      id: 2,
      name: 'Force Urbania',
      type: 'Vehicle Type',
      seats: 16,
      luggage: 16,
      price: 15000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: 'Force Urbania 16 seater for Chandigarh to Shimla'
    }],

    visitorsGuide: {
      intro: 'Chandigarh to Shimla Force Urbania luxury group travel with Advait Tour and Travels.',
      sections: [
      {
        title: 'Shimla Luxury Group Tour',
        content: 'Comfortable luxury travel to Shimla in Force Urbania.'
      }]
    },
    faqs: [
    { question: 'What is the Chandigarh to Shimla Force Urbania fare?', answer: 'Force Urbania fare starts at ₹13000 for 12 seater.' }],

    popularRoutesFrom: [
    { from: 'Chandigarh', to: 'Shimla', price: 13000 },
    { from: 'Chandigarh', to: 'Delhi', price: 14000 },
    { from: 'Chandigarh', to: 'Mussoorie', price: 2500 }],

    popularRoutesTo: [
    { from: 'Shimla', to: 'Chandigarh', price: 13000 },
    { from: 'Shimla', to: 'Delhi', price: 13000 },
    { from: 'Shimla', to: 'Mussoorie', price: 13000 }]
  },

  'chandigarh-amritsar-urbania': {
    from: 'Chandigarh',
    to: 'Amritsar',
    distance: '240 KM',
    duration: '4-5 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Force Urbania',
      type: 'Vehicle Type',
      seats: 12,
      luggage: 9,
      price: 18700,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: 'Force Urbania 12 seater for Chandigarh to Amritsar'
    },
    {
      id: 2,
      name: 'Force Urbania',
      type: 'Vehicle Type',
      seats: 16,
      luggage: 16,
      price: 21000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: 'Force Urbania 16 seater for Chandigarh to Amritsar'
    }],

    visitorsGuide: {
      intro: 'Chandigarh to Amritsar Force Urbania luxury group travel with Advait Tour and Travels.',
      sections: [
      {
        title: 'Amritsar Luxury Group Tour',
        content: 'Comfortable luxury travel to Amritsar in Force Urbania.'
      }]
    },
    faqs: [
    { question: 'What is the Chandigarh to Amritsar Force Urbania fare?', answer: 'Force Urbania fare starts at ₹18700 for 12 seater.' }],

    popularRoutesFrom: [
    { from: 'Chandigarh', to: 'Amritsar', price: 18700 },
    { from: 'Chandigarh', to: 'Delhi', price: 14000 },
    { from: 'Chandigarh', to: 'Shimla', price: 2500 }],

    popularRoutesTo: [
    { from: 'Amritsar', to: 'Chandigarh', price: 18700 },
    { from: 'Amritsar', to: 'Delhi', price: 18700 },
    { from: 'Amritsar', to: 'Shimla', price: 18700 }]
  },

  'chandigarh-dalhousie-urbania': {
    from: 'Chandigarh',
    to: 'Dalhousie',
    distance: '320 KM',
    duration: '7-8 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Force Urbania',
      type: 'Vehicle Type',
      seats: 12,
      luggage: 9,
      price: 43200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: 'Force Urbania 12 seater for Chandigarh to Dalhousie'
    },
    {
      id: 2,
      name: 'Force Urbania',
      type: 'Vehicle Type',
      seats: 16,
      luggage: 16,
      price: 46000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: 'Force Urbania 16 seater for Chandigarh to Dalhousie'
    }],

    visitorsGuide: {
      intro: 'Chandigarh to Dalhousie Force Urbania luxury group travel with Advait Tour and Travels.',
      sections: [
      {
        title: 'Dalhousie Luxury Group Tour',
        content: 'Comfortable luxury travel to Dalhousie in Force Urbania.'
      }]
    },
    faqs: [
    { question: 'What is the Chandigarh to Dalhousie Force Urbania fare?', answer: 'Force Urbania fare starts at ₹43200 for 12 seater.' }],

    popularRoutesFrom: [
    { from: 'Chandigarh', to: 'Dalhousie', price: 43200 },
    { from: 'Chandigarh', to: 'Delhi', price: 14000 },
    { from: 'Chandigarh', to: 'Shimla', price: 2500 }],

    popularRoutesTo: [
    { from: 'Dalhousie', to: 'Chandigarh', price: 43200 },
    { from: 'Dalhousie', to: 'Delhi', price: 43200 },
    { from: 'Dalhousie', to: 'Shimla', price: 43200 }]
  },

  'chandigarh-mussoorie-urbania': {
    from: 'Chandigarh',
    to: 'Mussoorie',
    distance: '170 KM',
    duration: '4-5 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Force Urbania',
      type: 'Vehicle Type',
      seats: 12,
      luggage: 9,
      price: 28800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: 'Force Urbania 12 seater for Chandigarh to Mussoorie'
    },
    {
      id: 2,
      name: 'Force Urbania',
      type: 'Vehicle Type',
      seats: 16,
      luggage: 16,
      price: 31000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: 'Force Urbania 16 seater for Chandigarh to Mussoorie'
    }],

    visitorsGuide: {
      intro: 'Chandigarh to Mussoorie Force Urbania luxury group travel with Advait Tour and Travels.',
      sections: [
      {
        title: 'Mussoorie Luxury Group Tour',
        content: 'Comfortable luxury travel to Mussoorie in Force Urbania.'
      }]
    },
    faqs: [
    { question: 'What is the Chandigarh to Mussoorie Force Urbania fare?', answer: 'Force Urbania fare starts at ₹28800 for 12 seater.' }],

    popularRoutesFrom: [
    { from: 'Chandigarh', to: 'Mussoorie', price: 28800 },
    { from: 'Chandigarh', to: 'Delhi', price: 14000 },
    { from: 'Chandigarh', to: 'Shimla', price: 2500 }],

    popularRoutesTo: [
    { from: 'Mussoorie', to: 'Chandigarh', price: 28800 },
    { from: 'Mussoorie', to: 'Delhi', price: 28800 },
    { from: 'Mussoorie', to: 'Shimla', price: 28800 }]
  },

  'chandigarh-himachal-urbania': {
    from: 'Chandigarh',
    to: 'Himachal Pradesh',
    distance: '250 KM',
    duration: '6-7 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Force Urbania',
      type: 'Vehicle Type',
      seats: 12,
      luggage: 9,
      price: 21600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: 'Force Urbania 12 seater for Chandigarh to Himachal'
    },
    {
      id: 2,
      name: 'Force Urbania',
      type: 'Vehicle Type',
      seats: 16,
      luggage: 16,
      price: 24000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: 'Force Urbania 16 seater for Chandigarh to Himachal'
    }],

    visitorsGuide: {
      intro: 'Chandigarh to Himachal Pradesh Force Urbania luxury group travel with Advait Tour and Travels.',
      sections: [
      {
        title: 'Himachal Luxury Group Tour',
        content: 'Comfortable luxury travel to Himachal Pradesh in Force Urbania.'
      }]
    },
    faqs: [
    { question: 'What is the Chandigarh to Himachal Force Urbania fare?', answer: 'Force Urbania fare starts at ₹21600 for 12 seater.' }],

    popularRoutesFrom: [
    { from: 'Chandigarh', to: 'Himachal Pradesh', price: 21600 },
    { from: 'Chandigarh', to: 'Delhi', price: 14000 },
    { from: 'Chandigarh', to: 'Shimla', price: 2500 }],

    popularRoutesTo: [
    { from: 'Himachal Pradesh', to: 'Chandigarh', price: 21600 },
    { from: 'Himachal Pradesh', to: 'Delhi', price: 21600 },
    { from: 'Himachal Pradesh', to: 'Shimla', price: 21600 }]
  },

  'chandigarh-vaishnodevi-urbania': {
    from: 'Chandigarh',
    to: 'Vaishno Devi',
    distance: '320 KM',
    duration: '7-8 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Force Urbania',
      type: 'Vehicle Type',
      seats: 12,
      luggage: 9,
      price: 36000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: 'Force Urbania 12 seater for Chandigarh to Vaishno Devi'
    },
    {
      id: 2,
      name: 'Force Urbania',
      type: 'Vehicle Type',
      seats: 16,
      luggage: 16,
      price: 39000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: 'Force Urbania 16 seater for Chandigarh to Vaishno Devi'
    }],

    visitorsGuide: {
      intro: 'Chandigarh to Vaishno Devi Force Urbania luxury pilgrimage travel with Advait Tour and Travels.',
      sections: [
      {
        title: 'Vaishno Devi Luxury Yatra',
        content: 'Comfortable luxury pilgrimage travel to Vaishno Devi in Force Urbania.'
      }]
    },
    faqs: [
    { question: 'What is the Chandigarh to Vaishno Devi Force Urbania fare?', answer: 'Force Urbania fare starts at ₹36000 for complete yatra package.' }],

    popularRoutesFrom: [
    { from: 'Chandigarh', to: 'Vaishno Devi', price: 36000 },
    { from: 'Chandigarh', to: 'Delhi', price: 14000 },
    { from: 'Chandigarh', to: 'Shimla', price: 2500 }],

    popularRoutesTo: [
    { from: 'Vaishno Devi', to: 'Chandigarh', price: 36000 },
    { from: 'Vaishno Devi', to: 'Delhi', price: 36000 },
    { from: 'Vaishno Devi', to: 'Shimla', price: 36000 }]
  },

  'chandigarh-haridwar-urbania': {
    from: 'Chandigarh',
    to: 'Haridwar',
    distance: '180 KM',
    duration: '4-5 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Force Urbania',
      type: 'Vehicle Type',
      seats: 12,
      luggage: 9,
      price: 18000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: 'Force Urbania 12 seater for Chandigarh to Haridwar'
    },
    {
      id: 2,
      name: 'Force Urbania',
      type: 'Vehicle Type',
      seats: 16,
      luggage: 16,
      price: 20000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: 'Force Urbania 16 seater for Chandigarh to Haridwar'
    }],

    visitorsGuide: {
      intro: 'Chandigarh to Haridwar Force Urbania luxury pilgrimage travel with Advait Tour and Travels.',
      sections: [
      {
        title: 'Haridwar Luxury Tour',
        content: 'Comfortable luxury pilgrimage travel to Haridwar in Force Urbania.'
      }]
    },
    faqs: [
    { question: 'What is the Chandigarh to Haridwar Force Urbania fare?', answer: 'Force Urbania fare starts at ₹18000 for 12 seater.' }],

    popularRoutesFrom: [
    { from: 'Chandigarh', to: 'Haridwar', price: 18000 },
    { from: 'Chandigarh', to: 'Delhi', price: 14000 },
    { from: 'Chandigarh', to: 'Shimla', price: 2500 }],

    popularRoutesTo: [
    { from: 'Haridwar', to: 'Chandigarh', price: 18000 },
    { from: 'Haridwar', to: 'Delhi', price: 18000 },
    { from: 'Haridwar', to: 'Shimla', price: 18000 }]
  },

  'chandigarh-chardham-urbania': {
    from: 'Chandigarh',
    to: 'Char Dham',
    distance: '450 KM',
    duration: '10-12 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Force Urbania',
      type: 'Vehicle Type',
      seats: 12,
      luggage: 9,
      price: 90000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: 'Force Urbania 12 seater for Chandigarh to Char Dham'
    },
    {
      id: 2,
      name: 'Force Urbania',
      type: 'Vehicle Type',
      seats: 16,
      luggage: 16,
      price: 95000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: 'Force Urbania 16 seater for Chandigarh to Char Dham'
    }],

    visitorsGuide: {
      intro: 'Chandigarh to Char Dham Force Urbania luxury pilgrimage package with Advait Tour and Travels.',
      sections: [
      {
        title: 'Char Dham Luxury Yatra',
        content: 'Complete Char Dham yatra in luxury Force Urbania.'
      }]
    },
    faqs: [
    { question: 'What is the Chandigarh to Char Dham Force Urbania fare?', answer: 'Force Urbania fare starts at ₹90000 for complete yatra package.' }],

    popularRoutesFrom: [
    { from: 'Chandigarh', to: 'Char Dham', price: 90000 },
    { from: 'Chandigarh', to: 'Delhi', price: 14000 },
    { from: 'Chandigarh', to: 'Shimla', price: 2500 }],

    popularRoutesTo: [
    { from: 'Char Dham', to: 'Chandigarh', price: 90000 },
    { from: 'Char Dham', to: 'Delhi', price: 90000 },
    { from: 'Char Dham', to: 'Shimla', price: 90000 }]
  },

  'chandigarh-jaipur-urbania': {
    from: 'Chandigarh',
    to: 'Jaipur',
    distance: '520 KM',
    duration: '8-9 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Force Urbania',
      type: 'Vehicle Type',
      seats: 12,
      luggage: 9,
      price: 43200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: 'Force Urbania 12 seater for Chandigarh to Jaipur'
    },
    {
      id: 2,
      name: 'Force Urbania',
      type: 'Vehicle Type',
      seats: 16,
      luggage: 16,
      price: 46000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: 'Force Urbania 16 seater for Chandigarh to Jaipur'
    }],

    visitorsGuide: {
      intro: 'Chandigarh to Jaipur Force Urbania luxury group travel with Advait Tour and Travels.',
      sections: [
      {
        title: 'Jaipur Luxury Group Tour',
        content: 'Comfortable luxury travel to Jaipur in Force Urbania.'
      }]
    },
    faqs: [
    { question: 'What is the Chandigarh to Jaipur Force Urbania fare?', answer: 'Force Urbania fare starts at ₹43200 for 12 seater.' }],

    popularRoutesFrom: [
    { from: 'Chandigarh', to: 'Jaipur', price: 43200 },
    { from: 'Chandigarh', to: 'Delhi', price: 14000 },
    { from: 'Chandigarh', to: 'Shimla', price: 2500 }],

    popularRoutesTo: [
    { from: 'Jaipur', to: 'Chandigarh', price: 43200 },
    { from: 'Jaipur', to: 'Delhi', price: 43200 },
    { from: 'Jaipur', to: 'Shimla', price: 43200 }]
  },

  'chandigarh-agra-urbania': {
    from: 'Chandigarh',
    to: 'Agra',
    distance: '420 KM',
    duration: '7-8 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Force Urbania',
      type: 'Vehicle Type',
      seats: 12,
      luggage: 9,
      price: 43200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: 'Force Urbania 12 seater for Chandigarh to Agra'
    },
    {
      id: 2,
      name: 'Force Urbania',
      type: 'Vehicle Type',
      seats: 16,
      luggage: 16,
      price: 46000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: 'Force Urbania 16 seater for Chandigarh to Agra'
    }],

    visitorsGuide: {
      intro: 'Chandigarh to Agra Force Urbania luxury group travel with Advait Tour and Travels.',
      sections: [
      {
        title: 'Agra Luxury Group Tour',
        content: 'Comfortable luxury travel to Agra in Force Urbania.'
      }]
    },
    faqs: [
    { question: 'What is the Chandigarh to Agra Force Urbania fare?', answer: 'Force Urbania fare starts at ₹43200 for 12 seater.' }],

    popularRoutesFrom: [
    { from: 'Chandigarh', to: 'Agra', price: 43200 },
    { from: 'Chandigarh', to: 'Delhi', price: 14000 },
    { from: 'Chandigarh', to: 'Shimla', price: 2500 }],

    popularRoutesTo: [
    { from: 'Agra', to: 'Chandigarh', price: 43200 },
    { from: 'Agra', to: 'Delhi', price: 43200 },
    { from: 'Agra', to: 'Shimla', price: 43200 }]
  },

  'chandigarh-dehradun-urbania': {
    from: 'Chandigarh',
    to: 'Dehradun',
    distance: '170 KM',
    duration: '4-5 hours',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    vehicles: [
    {
      id: 1,
      name: 'Force Urbania',
      type: 'Vehicle Type',
      seats: 12,
      luggage: 9,
      price: 16600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: 'Force Urbania 12 seater for Chandigarh to Dehradun'
    },
    {
      id: 2,
      name: 'Force Urbania',
      type: 'Vehicle Type',
      seats: 16,
      luggage: 16,
      price: 19000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: 'Force Urbania 16 seater for Chandigarh to Dehradun'
    }],

    visitorsGuide: {
      intro: 'Chandigarh to Dehradun Force Urbania luxury group travel with Advait Tour and Travels.',
      sections: [
      {
        title: 'Dehradun Luxury Group Tour',
        content: 'Comfortable luxury travel to Dehradun in Force Urbania.'
      }]
    },
    faqs: [
    { question: 'What is the Chandigarh to Dehradun Force Urbania fare?', answer: 'Force Urbania fare starts at ₹16600 for 12 seater.' }],

    popularRoutesFrom: [
    { from: 'Chandigarh', to: 'Dehradun', price: 16600 },
    { from: 'Chandigarh', to: 'Delhi', price: 14000 },
    { from: 'Chandigarh', to: 'Shimla', price: 2500 }],

    popularRoutesTo: [
    { from: 'Dehradun', to: 'Chandigarh', price: 16600 },
    { from: 'Dehradun', to: 'Delhi', price: 16600 },
    { from: 'Dehradun', to: 'Shimla', price: 16600 }]
  }
};

export default routeData;